import { GraphQLClient } from 'graphql-request'
import { RequestInit } from 'graphql-request/dist/types.dom'
import {
  useQuery,
  useInfiniteQuery,
  useMutation,
  UseQueryOptions,
  UseInfiniteQueryOptions,
  UseMutationOptions,
  QueryFunctionContext
} from 'react-query'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }

function fetcher<TData, TVariables>(
  client: GraphQLClient,
  query: string,
  variables?: TVariables,
  headers?: RequestInit['headers']
) {
  return async (): Promise<TData> => client.request<TData, TVariables>(query, variables, headers)
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any
  /** A string used to identify an i18n locale */
  I18NLocaleCode: any
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any
  MenuCategoryDynamicZoneInput: any
  /** The `Upload` scalar type represents a file upload. */
  Upload: any
  UsersPermissionsUserTestsDynamicZoneInput: any
}

export type AdminCategory = {
  __typename?: 'AdminCategory'
  category_id?: Maybe<Scalars['ID']>
  category_title?: Maybe<Scalars['String']>
  hidden_products_count?: Maybe<Scalars['Int']>
  is_offline?: Maybe<Scalars['Boolean']>
  is_partially_offline?: Maybe<Scalars['Boolean']>
  menu_title?: Maybe<Scalars['String']>
  product_ids?: Maybe<Array<Maybe<Scalars['ID']>>>
  total_products?: Maybe<Scalars['Int']>
  visible_products_count?: Maybe<Scalars['Int']>
}

export type AllProductsRes = {
  __typename?: 'AllProductsRes'
  categories?: Maybe<Array<Maybe<AdminCategory>>>
  products?: Maybe<Array<Maybe<Products>>>
  title?: Maybe<Scalars['String']>
}

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>
  contains?: InputMaybe<Scalars['Boolean']>
  containsi?: InputMaybe<Scalars['Boolean']>
  endsWith?: InputMaybe<Scalars['Boolean']>
  eq?: InputMaybe<Scalars['Boolean']>
  gt?: InputMaybe<Scalars['Boolean']>
  gte?: InputMaybe<Scalars['Boolean']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>
  lt?: InputMaybe<Scalars['Boolean']>
  lte?: InputMaybe<Scalars['Boolean']>
  ne?: InputMaybe<Scalars['Boolean']>
  not?: InputMaybe<BooleanFilterInput>
  notContains?: InputMaybe<Scalars['Boolean']>
  notContainsi?: InputMaybe<Scalars['Boolean']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>
  notNull?: InputMaybe<Scalars['Boolean']>
  null?: InputMaybe<Scalars['Boolean']>
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>
  startsWith?: InputMaybe<Scalars['Boolean']>
}

export type ComponentCategoriesCategory = {
  __typename?: 'ComponentCategoriesCategory'
  background_color?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  footer_description?: Maybe<Scalars['String']>
  force_open?: Maybe<Scalars['Boolean']>
  force_show?: Maybe<Scalars['Boolean']>
  gif_placement?: Maybe<Enum_Componentcategoriescategory_Gif_Placement>
  hide_filters?: Maybe<Scalars['Boolean']>
  hide_products?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  image?: Maybe<UploadFileEntityResponse>
  menu_title?: Maybe<Scalars['String']>
  product?: Maybe<Array<Maybe<ComponentProductsProduct>>>
  subtitle?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  title_section1_filter?: Maybe<Scalars['String']>
  title_section2_filter?: Maybe<Scalars['String']>
}

export type ComponentCategoriesCategoryProductArgs = {
  filters?: InputMaybe<ComponentProductsProductFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ComponentProductsProduct = {
  __typename?: 'ComponentProductsProduct'
  all_services?: Maybe<Scalars['Boolean']>
  allergens?: Maybe<Scalars['String']>
  forced_description?: Maybe<Scalars['String']>
  forced_title?: Maybe<Scalars['String']>
  id: Scalars['ID']
  is_unavailable?: Maybe<Scalars['Boolean']>
  price?: Maybe<Scalars['String']>
  product?: Maybe<ProductEntityResponse>
  services?: Maybe<ServiceRelationResponseCollection>
  sub_category?: Maybe<SubCategoryEntityResponse>
  title?: Maybe<Scalars['String']>
}

export type ComponentProductsProductServicesArgs = {
  filters?: InputMaybe<ServiceFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ComponentProductsProductFiltersInput = {
  all_services?: InputMaybe<BooleanFilterInput>
  allergens?: InputMaybe<StringFilterInput>
  and?: InputMaybe<Array<InputMaybe<ComponentProductsProductFiltersInput>>>
  forced_description?: InputMaybe<StringFilterInput>
  forced_title?: InputMaybe<StringFilterInput>
  is_unavailable?: InputMaybe<BooleanFilterInput>
  not?: InputMaybe<ComponentProductsProductFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentProductsProductFiltersInput>>>
  price?: InputMaybe<StringFilterInput>
  product?: InputMaybe<ProductFiltersInput>
  services?: InputMaybe<ServiceFiltersInput>
  sub_category?: InputMaybe<SubCategoryFiltersInput>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentProductsProductInput = {
  all_services?: InputMaybe<Scalars['Boolean']>
  allergens?: InputMaybe<Scalars['String']>
  forced_description?: InputMaybe<Scalars['String']>
  forced_title?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['ID']>
  is_unavailable?: InputMaybe<Scalars['Boolean']>
  price?: InputMaybe<Scalars['String']>
  product?: InputMaybe<Scalars['ID']>
  services?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  sub_category?: InputMaybe<Scalars['ID']>
  title?: InputMaybe<Scalars['String']>
}

export type ComponentServicesService = {
  __typename?: 'ComponentServicesService'
  days?: Maybe<DayRelationResponseCollection>
  endHours?: Maybe<Scalars['Int']>
  endMinutes?: Maybe<Scalars['Int']>
  id: Scalars['ID']
  service?: Maybe<ServiceEntityResponse>
  startHours?: Maybe<Scalars['Int']>
  startMinutes?: Maybe<Scalars['Int']>
}

export type ComponentServicesServiceDaysArgs = {
  filters?: InputMaybe<DayFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ComponentServicesServiceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentServicesServiceFiltersInput>>>
  days?: InputMaybe<DayFiltersInput>
  endHours?: InputMaybe<IntFilterInput>
  endMinutes?: InputMaybe<IntFilterInput>
  not?: InputMaybe<ComponentServicesServiceFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentServicesServiceFiltersInput>>>
  service?: InputMaybe<ServiceFiltersInput>
  startHours?: InputMaybe<IntFilterInput>
  startMinutes?: InputMaybe<IntFilterInput>
}

export type ComponentServicesServiceInput = {
  days?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  endHours?: InputMaybe<Scalars['Int']>
  endMinutes?: InputMaybe<Scalars['Int']>
  id?: InputMaybe<Scalars['ID']>
  service?: InputMaybe<Scalars['ID']>
  startHours?: InputMaybe<Scalars['Int']>
  startMinutes?: InputMaybe<Scalars['Int']>
}

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
  contains?: InputMaybe<Scalars['DateTime']>
  containsi?: InputMaybe<Scalars['DateTime']>
  endsWith?: InputMaybe<Scalars['DateTime']>
  eq?: InputMaybe<Scalars['DateTime']>
  gt?: InputMaybe<Scalars['DateTime']>
  gte?: InputMaybe<Scalars['DateTime']>
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
  lt?: InputMaybe<Scalars['DateTime']>
  lte?: InputMaybe<Scalars['DateTime']>
  ne?: InputMaybe<Scalars['DateTime']>
  not?: InputMaybe<DateTimeFilterInput>
  notContains?: InputMaybe<Scalars['DateTime']>
  notContainsi?: InputMaybe<Scalars['DateTime']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
  notNull?: InputMaybe<Scalars['Boolean']>
  null?: InputMaybe<Scalars['Boolean']>
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
  startsWith?: InputMaybe<Scalars['DateTime']>
}

export type Day = {
  __typename?: 'Day'
  createdAt?: Maybe<Scalars['DateTime']>
  menu?: Maybe<MenuEntityResponse>
  publishedAt?: Maybe<Scalars['DateTime']>
  title?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type DayEntity = {
  __typename?: 'DayEntity'
  attributes?: Maybe<Day>
  id?: Maybe<Scalars['ID']>
}

export type DayEntityResponse = {
  __typename?: 'DayEntityResponse'
  data?: Maybe<DayEntity>
}

export type DayEntityResponseCollection = {
  __typename?: 'DayEntityResponseCollection'
  data: Array<DayEntity>
  meta: ResponseCollectionMeta
}

export type DayFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DayFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  menu?: InputMaybe<MenuFiltersInput>
  not?: InputMaybe<DayFiltersInput>
  or?: InputMaybe<Array<InputMaybe<DayFiltersInput>>>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  title?: InputMaybe<StringFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type DayInput = {
  menu?: InputMaybe<Scalars['ID']>
  publishedAt?: InputMaybe<Scalars['DateTime']>
  title?: InputMaybe<Scalars['String']>
}

export type DayRelationResponseCollection = {
  __typename?: 'DayRelationResponseCollection'
  data: Array<DayEntity>
}

export enum Enum_Componentcategoriescategory_Gif_Placement {
  BottomLeft = 'bottom_left',
  BottomRight = 'bottom_right',
  TopLeft = 'top_left',
  TopRight = 'top_right'
}

export enum Enum_Menu_Locale {
  Ar = 'ar',
  Ca = 'ca',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
  Nl = 'nl'
}

export enum Enum_Menu_Timezone {
  AfricaAbidjan = 'Africa_Abidjan',
  AfricaAccra = 'Africa_Accra',
  AfricaAddisAbaba = 'Africa_Addis_Ababa',
  AfricaAlgiers = 'Africa_Algiers',
  AfricaAsmara = 'Africa_Asmara',
  AfricaBamako = 'Africa_Bamako',
  AfricaBangui = 'Africa_Bangui',
  AfricaBanjul = 'Africa_Banjul',
  AfricaBissau = 'Africa_Bissau',
  AfricaBlantyre = 'Africa_Blantyre',
  AfricaBrazzaville = 'Africa_Brazzaville',
  AfricaBujumbura = 'Africa_Bujumbura',
  AfricaCairo = 'Africa_Cairo',
  AfricaCasablanca = 'Africa_Casablanca',
  AfricaCeuta = 'Africa_Ceuta',
  AfricaConakry = 'Africa_Conakry',
  AfricaDakar = 'Africa_Dakar',
  AfricaDarEsSalaam = 'Africa_Dar_es_Salaam',
  AfricaDjibouti = 'Africa_Djibouti',
  AfricaDouala = 'Africa_Douala',
  AfricaElAaiun = 'Africa_El_Aaiun',
  AfricaFreetown = 'Africa_Freetown',
  AfricaGaborone = 'Africa_Gaborone',
  AfricaHarare = 'Africa_Harare',
  AfricaJohannesburg = 'Africa_Johannesburg',
  AfricaJuba = 'Africa_Juba',
  AfricaKampala = 'Africa_Kampala',
  AfricaKhartoum = 'Africa_Khartoum',
  AfricaKigali = 'Africa_Kigali',
  AfricaKinshasa = 'Africa_Kinshasa',
  AfricaLagos = 'Africa_Lagos',
  AfricaLibreville = 'Africa_Libreville',
  AfricaLome = 'Africa_Lome',
  AfricaLuanda = 'Africa_Luanda',
  AfricaLubumbashi = 'Africa_Lubumbashi',
  AfricaLusaka = 'Africa_Lusaka',
  AfricaMalabo = 'Africa_Malabo',
  AfricaMaputo = 'Africa_Maputo',
  AfricaMaseru = 'Africa_Maseru',
  AfricaMbabane = 'Africa_Mbabane',
  AfricaMogadishu = 'Africa_Mogadishu',
  AfricaMonrovia = 'Africa_Monrovia',
  AfricaNairobi = 'Africa_Nairobi',
  AfricaNdjamena = 'Africa_Ndjamena',
  AfricaNiamey = 'Africa_Niamey',
  AfricaNouakchott = 'Africa_Nouakchott',
  AfricaOuagadougou = 'Africa_Ouagadougou',
  AfricaPortoNovo = 'Africa_Porto_Novo',
  AfricaSaoTome = 'Africa_Sao_Tome',
  AfricaTripoli = 'Africa_Tripoli',
  AfricaTunis = 'Africa_Tunis',
  AfricaWindhoek = 'Africa_Windhoek',
  AmericaAdak = 'America_Adak',
  AmericaAnchorage = 'America_Anchorage',
  AmericaAnguilla = 'America_Anguilla',
  AmericaAntigua = 'America_Antigua',
  AmericaAraguaina = 'America_Araguaina',
  AmericaArgentinaBuenosA = 'America_Argentina_Buenos_A',
  AmericaArgentinaCatamarc = 'America_Argentina_Catamarc',
  AmericaArgentinaCordoba = 'America_Argentina_Cordoba',
  AmericaArgentinaJujuy = 'America_Argentina_Jujuy',
  AmericaArgentinaLaRioja = 'America_Argentina_La_Rioja',
  AmericaArgentinaMendoza = 'America_Argentina_Mendoza',
  AmericaArgentinaRioGall = 'America_Argentina_Rio_Gall',
  AmericaArgentinaSalta = 'America_Argentina_Salta',
  AmericaArgentinaSanJuan = 'America_Argentina_San_Juan',
  AmericaArgentinaSanLuis = 'America_Argentina_San_Luis',
  AmericaArgentinaTucuman = 'America_Argentina_Tucuman',
  AmericaArgentinaUshuaia = 'America_Argentina_Ushuaia',
  AmericaAruba = 'America_Aruba',
  AmericaAsuncion = 'America_Asuncion',
  AmericaAtikokan = 'America_Atikokan',
  AmericaBahia = 'America_Bahia',
  AmericaBahiaBanderas = 'America_Bahia_Banderas',
  AmericaBarbados = 'America_Barbados',
  AmericaBelem = 'America_Belem',
  AmericaBelize = 'America_Belize',
  AmericaBlancSablon = 'America_Blanc_Sablon',
  AmericaBoaVista = 'America_Boa_Vista',
  AmericaBogota = 'America_Bogota',
  AmericaBoise = 'America_Boise',
  AmericaCambridgeBay = 'America_Cambridge_Bay',
  AmericaCampoGrande = 'America_Campo_Grande',
  AmericaCancun = 'America_Cancun',
  AmericaCaracas = 'America_Caracas',
  AmericaCayenne = 'America_Cayenne',
  AmericaCayman = 'America_Cayman',
  AmericaChicago = 'America_Chicago',
  AmericaChihuahua = 'America_Chihuahua',
  AmericaCostaRica = 'America_Costa_Rica',
  AmericaCreston = 'America_Creston',
  AmericaCuiaba = 'America_Cuiaba',
  AmericaCuracao = 'America_Curacao',
  AmericaDanmarkshavn = 'America_Danmarkshavn',
  AmericaDawson = 'America_Dawson',
  AmericaDawsonCreek = 'America_Dawson_Creek',
  AmericaDenver = 'America_Denver',
  AmericaDetroit = 'America_Detroit',
  AmericaDominica = 'America_Dominica',
  AmericaEdmonton = 'America_Edmonton',
  AmericaEirunepe = 'America_Eirunepe',
  AmericaElSalvador = 'America_El_Salvador',
  AmericaFortNelson = 'America_Fort_Nelson',
  AmericaFortaleza = 'America_Fortaleza',
  AmericaGlaceBay = 'America_Glace_Bay',
  AmericaGodthab = 'America_Godthab',
  AmericaGooseBay = 'America_Goose_Bay',
  AmericaGrandTurk = 'America_Grand_Turk',
  AmericaGrenada = 'America_Grenada',
  AmericaGuadeloupe = 'America_Guadeloupe',
  AmericaGuatemala = 'America_Guatemala',
  AmericaGuayaquil = 'America_Guayaquil',
  AmericaGuyana = 'America_Guyana',
  AmericaHalifax = 'America_Halifax',
  AmericaHavana = 'America_Havana',
  AmericaHermosillo = 'America_Hermosillo',
  AmericaIndianaIndianapol = 'America_Indiana_Indianapol',
  AmericaIndianaKnox = 'America_Indiana_Knox',
  AmericaIndianaMarengo = 'America_Indiana_Marengo',
  AmericaIndianaPetersburg = 'America_Indiana_Petersburg',
  AmericaIndianaTellCity = 'America_Indiana_Tell_City',
  AmericaIndianaVevay = 'America_Indiana_Vevay',
  AmericaIndianaVincennes = 'America_Indiana_Vincennes',
  AmericaIndianaWinamac = 'America_Indiana_Winamac',
  AmericaInuvik = 'America_Inuvik',
  AmericaIqaluit = 'America_Iqaluit',
  AmericaJamaica = 'America_Jamaica',
  AmericaJuneau = 'America_Juneau',
  AmericaKentuckyLouisvill = 'America_Kentucky_Louisvill',
  AmericaKentuckyMonticell = 'America_Kentucky_Monticell',
  AmericaKralendijk = 'America_Kralendijk',
  AmericaLaPaz = 'America_La_Paz',
  AmericaLima = 'America_Lima',
  AmericaLosAngeles = 'America_Los_Angeles',
  AmericaLowerPrinces = 'America_Lower_Princes',
  AmericaMaceio = 'America_Maceio',
  AmericaManagua = 'America_Managua',
  AmericaManaus = 'America_Manaus',
  AmericaMarigot = 'America_Marigot',
  AmericaMartinique = 'America_Martinique',
  AmericaMatamoros = 'America_Matamoros',
  AmericaMazatlan = 'America_Mazatlan',
  AmericaMenominee = 'America_Menominee',
  AmericaMerida = 'America_Merida',
  AmericaMetlakatla = 'America_Metlakatla',
  AmericaMexicoCity = 'America_Mexico_City',
  AmericaMiquelon = 'America_Miquelon',
  AmericaMoncton = 'America_Moncton',
  AmericaMonterrey = 'America_Monterrey',
  AmericaMontevideo = 'America_Montevideo',
  AmericaMontserrat = 'America_Montserrat',
  AmericaNassau = 'America_Nassau',
  AmericaNewYork = 'America_New_York',
  AmericaNipigon = 'America_Nipigon',
  AmericaNome = 'America_Nome',
  AmericaNoronha = 'America_Noronha',
  AmericaNorthDakotaBeula = 'America_North_Dakota_Beula',
  AmericaNorthDakotaCente = 'America_North_Dakota_Cente',
  AmericaNorthDakotaNewS = 'America_North_Dakota_New_S',
  AmericaOjinaga = 'America_Ojinaga',
  AmericaPanama = 'America_Panama',
  AmericaPangnirtung = 'America_Pangnirtung',
  AmericaParamaribo = 'America_Paramaribo',
  AmericaPhoenix = 'America_Phoenix',
  AmericaPortAuPrince = 'America_Port_au_Prince',
  AmericaPortOfSpain = 'America_Port_of_Spain',
  AmericaPortoVelho = 'America_Porto_Velho',
  AmericaPuertoRico = 'America_Puerto_Rico',
  AmericaRainyRiver = 'America_Rainy_River',
  AmericaRankinInlet = 'America_Rankin_Inlet',
  AmericaRecife = 'America_Recife',
  AmericaRegina = 'America_Regina',
  AmericaResolute = 'America_Resolute',
  AmericaRioBranco = 'America_Rio_Branco',
  AmericaSantaIsabel = 'America_Santa_Isabel',
  AmericaSantarem = 'America_Santarem',
  AmericaSantiago = 'America_Santiago',
  AmericaSantoDomingo = 'America_Santo_Domingo',
  AmericaSaoPaulo = 'America_Sao_Paulo',
  AmericaScoresbysund = 'America_Scoresbysund',
  AmericaSitka = 'America_Sitka',
  AmericaStBarthelemy = 'America_St_Barthelemy',
  AmericaStJohns = 'America_St_Johns',
  AmericaStKitts = 'America_St_Kitts',
  AmericaStLucia = 'America_St_Lucia',
  AmericaStThomas = 'America_St_Thomas',
  AmericaStVincent = 'America_St_Vincent',
  AmericaSwiftCurrent = 'America_Swift_Current',
  AmericaTegucigalpa = 'America_Tegucigalpa',
  AmericaThule = 'America_Thule',
  AmericaThunderBay = 'America_Thunder_Bay',
  AmericaTijuana = 'America_Tijuana',
  AmericaToronto = 'America_Toronto',
  AmericaTortola = 'America_Tortola',
  AmericaVancouver = 'America_Vancouver',
  AmericaWhitehorse = 'America_Whitehorse',
  AmericaWinnipeg = 'America_Winnipeg',
  AmericaYakutat = 'America_Yakutat',
  AmericaYellowknife = 'America_Yellowknife',
  AntarcticaCasey = 'Antarctica_Casey',
  AntarcticaDavis = 'Antarctica_Davis',
  AntarcticaDumontDUrville = 'Antarctica_DumontDUrville',
  AntarcticaMacquarie = 'Antarctica_Macquarie',
  AntarcticaMawson = 'Antarctica_Mawson',
  AntarcticaMcMurdo = 'Antarctica_McMurdo',
  AntarcticaPalmer = 'Antarctica_Palmer',
  AntarcticaRothera = 'Antarctica_Rothera',
  AntarcticaSyowa = 'Antarctica_Syowa',
  AntarcticaTroll = 'Antarctica_Troll',
  AntarcticaVostok = 'Antarctica_Vostok',
  ArcticLongyearbyen = 'Arctic_Longyearbyen',
  AsiaAden = 'Asia_Aden',
  AsiaAlmaty = 'Asia_Almaty',
  AsiaAmman = 'Asia_Amman',
  AsiaAnadyr = 'Asia_Anadyr',
  AsiaAqtau = 'Asia_Aqtau',
  AsiaAqtobe = 'Asia_Aqtobe',
  AsiaAshgabat = 'Asia_Ashgabat',
  AsiaBaghdad = 'Asia_Baghdad',
  AsiaBahrain = 'Asia_Bahrain',
  AsiaBaku = 'Asia_Baku',
  AsiaBangkok = 'Asia_Bangkok',
  AsiaBeirut = 'Asia_Beirut',
  AsiaBishkek = 'Asia_Bishkek',
  AsiaBrunei = 'Asia_Brunei',
  AsiaChita = 'Asia_Chita',
  AsiaChoibalsan = 'Asia_Choibalsan',
  AsiaColombo = 'Asia_Colombo',
  AsiaDamascus = 'Asia_Damascus',
  AsiaDhaka = 'Asia_Dhaka',
  AsiaDili = 'Asia_Dili',
  AsiaDubai = 'Asia_Dubai',
  AsiaDushanbe = 'Asia_Dushanbe',
  AsiaGaza = 'Asia_Gaza',
  AsiaHebron = 'Asia_Hebron',
  AsiaHoChiMinh = 'Asia_Ho_Chi_Minh',
  AsiaHongKong = 'Asia_Hong_Kong',
  AsiaHovd = 'Asia_Hovd',
  AsiaIrkutsk = 'Asia_Irkutsk',
  AsiaJakarta = 'Asia_Jakarta',
  AsiaJayapura = 'Asia_Jayapura',
  AsiaJerusalem = 'Asia_Jerusalem',
  AsiaKabul = 'Asia_Kabul',
  AsiaKamchatka = 'Asia_Kamchatka',
  AsiaKarachi = 'Asia_Karachi',
  AsiaKathmandu = 'Asia_Kathmandu',
  AsiaKhandyga = 'Asia_Khandyga',
  AsiaKolkata = 'Asia_Kolkata',
  AsiaKrasnoyarsk = 'Asia_Krasnoyarsk',
  AsiaKualaLumpur = 'Asia_Kuala_Lumpur',
  AsiaKuching = 'Asia_Kuching',
  AsiaKuwait = 'Asia_Kuwait',
  AsiaMacau = 'Asia_Macau',
  AsiaMagadan = 'Asia_Magadan',
  AsiaMakassar = 'Asia_Makassar',
  AsiaManila = 'Asia_Manila',
  AsiaMuscat = 'Asia_Muscat',
  AsiaNicosia = 'Asia_Nicosia',
  AsiaNovokuznetsk = 'Asia_Novokuznetsk',
  AsiaNovosibirsk = 'Asia_Novosibirsk',
  AsiaOmsk = 'Asia_Omsk',
  AsiaOral = 'Asia_Oral',
  AsiaPhnomPenh = 'Asia_Phnom_Penh',
  AsiaPontianak = 'Asia_Pontianak',
  AsiaPyongyang = 'Asia_Pyongyang',
  AsiaQatar = 'Asia_Qatar',
  AsiaQyzylorda = 'Asia_Qyzylorda',
  AsiaRangoon = 'Asia_Rangoon',
  AsiaRiyadh = 'Asia_Riyadh',
  AsiaSakhalin = 'Asia_Sakhalin',
  AsiaSamarkand = 'Asia_Samarkand',
  AsiaSeoul = 'Asia_Seoul',
  AsiaShanghai = 'Asia_Shanghai',
  AsiaSingapore = 'Asia_Singapore',
  AsiaSrednekolymsk = 'Asia_Srednekolymsk',
  AsiaTaipei = 'Asia_Taipei',
  AsiaTashkent = 'Asia_Tashkent',
  AsiaTbilisi = 'Asia_Tbilisi',
  AsiaTehran = 'Asia_Tehran',
  AsiaThimphu = 'Asia_Thimphu',
  AsiaTokyo = 'Asia_Tokyo',
  AsiaUlaanbaatar = 'Asia_Ulaanbaatar',
  AsiaUrumqi = 'Asia_Urumqi',
  AsiaUstNera = 'Asia_Ust_Nera',
  AsiaVientiane = 'Asia_Vientiane',
  AsiaVladivostok = 'Asia_Vladivostok',
  AsiaYakutsk = 'Asia_Yakutsk',
  AsiaYekaterinburg = 'Asia_Yekaterinburg',
  AsiaYerevan = 'Asia_Yerevan',
  AtlanticAzores = 'Atlantic_Azores',
  AtlanticBermuda = 'Atlantic_Bermuda',
  AtlanticCanary = 'Atlantic_Canary',
  AtlanticCapeVerde = 'Atlantic_Cape_Verde',
  AtlanticFaroe = 'Atlantic_Faroe',
  AtlanticMadeira = 'Atlantic_Madeira',
  AtlanticReykjavik = 'Atlantic_Reykjavik',
  AtlanticSouthGeorgia = 'Atlantic_South_Georgia',
  AtlanticStHelena = 'Atlantic_St_Helena',
  AtlanticStanley = 'Atlantic_Stanley',
  AustraliaAdelaide = 'Australia_Adelaide',
  AustraliaBrisbane = 'Australia_Brisbane',
  AustraliaBrokenHill = 'Australia_Broken_Hill',
  AustraliaCurrie = 'Australia_Currie',
  AustraliaDarwin = 'Australia_Darwin',
  AustraliaEucla = 'Australia_Eucla',
  AustraliaHobart = 'Australia_Hobart',
  AustraliaLindeman = 'Australia_Lindeman',
  AustraliaLordHowe = 'Australia_Lord_Howe',
  AustraliaMelbourne = 'Australia_Melbourne',
  AustraliaPerth = 'Australia_Perth',
  AustraliaSydney = 'Australia_Sydney',
  EuropeAmsterdam = 'Europe_Amsterdam',
  EuropeAndorra = 'Europe_Andorra',
  EuropeAthens = 'Europe_Athens',
  EuropeBelgrade = 'Europe_Belgrade',
  EuropeBerlin = 'Europe_Berlin',
  EuropeBratislava = 'Europe_Bratislava',
  EuropeBrussels = 'Europe_Brussels',
  EuropeBucharest = 'Europe_Bucharest',
  EuropeBudapest = 'Europe_Budapest',
  EuropeBusingen = 'Europe_Busingen',
  EuropeChisinau = 'Europe_Chisinau',
  EuropeCopenhagen = 'Europe_Copenhagen',
  EuropeDublin = 'Europe_Dublin',
  EuropeGibraltar = 'Europe_Gibraltar',
  EuropeGuernsey = 'Europe_Guernsey',
  EuropeHelsinki = 'Europe_Helsinki',
  EuropeIsleOfMan = 'Europe_Isle_of_Man',
  EuropeIstanbul = 'Europe_Istanbul',
  EuropeJersey = 'Europe_Jersey',
  EuropeKaliningrad = 'Europe_Kaliningrad',
  EuropeKiev = 'Europe_Kiev',
  EuropeLisbon = 'Europe_Lisbon',
  EuropeLjubljana = 'Europe_Ljubljana',
  EuropeLondon = 'Europe_London',
  EuropeLuxembourg = 'Europe_Luxembourg',
  EuropeMadrid = 'Europe_Madrid',
  EuropeMalta = 'Europe_Malta',
  EuropeMariehamn = 'Europe_Mariehamn',
  EuropeMinsk = 'Europe_Minsk',
  EuropeMonaco = 'Europe_Monaco',
  EuropeMoscow = 'Europe_Moscow',
  EuropeOslo = 'Europe_Oslo',
  EuropeParis = 'Europe_Paris',
  EuropePodgorica = 'Europe_Podgorica',
  EuropePrague = 'Europe_Prague',
  EuropeRiga = 'Europe_Riga',
  EuropeRome = 'Europe_Rome',
  EuropeSamara = 'Europe_Samara',
  EuropeSanMarino = 'Europe_San_Marino',
  EuropeSarajevo = 'Europe_Sarajevo',
  EuropeSimferopol = 'Europe_Simferopol',
  EuropeSkopje = 'Europe_Skopje',
  EuropeSofia = 'Europe_Sofia',
  EuropeStockholm = 'Europe_Stockholm',
  EuropeTallinn = 'Europe_Tallinn',
  EuropeTirane = 'Europe_Tirane',
  EuropeUzhgorod = 'Europe_Uzhgorod',
  EuropeVaduz = 'Europe_Vaduz',
  EuropeVatican = 'Europe_Vatican',
  EuropeVienna = 'Europe_Vienna',
  EuropeVilnius = 'Europe_Vilnius',
  EuropeVolgograd = 'Europe_Volgograd',
  EuropeWarsaw = 'Europe_Warsaw',
  EuropeZagreb = 'Europe_Zagreb',
  EuropeZaporozhye = 'Europe_Zaporozhye',
  EuropeZurich = 'Europe_Zurich',
  IndianAntananarivo = 'Indian_Antananarivo',
  IndianChagos = 'Indian_Chagos',
  IndianChristmas = 'Indian_Christmas',
  IndianCocos = 'Indian_Cocos',
  IndianComoro = 'Indian_Comoro',
  IndianKerguelen = 'Indian_Kerguelen',
  IndianMahe = 'Indian_Mahe',
  IndianMaldives = 'Indian_Maldives',
  IndianMauritius = 'Indian_Mauritius',
  IndianMayotte = 'Indian_Mayotte',
  IndianReunion = 'Indian_Reunion',
  PacificApia = 'Pacific_Apia',
  PacificAuckland = 'Pacific_Auckland',
  PacificBougainville = 'Pacific_Bougainville',
  PacificChatham = 'Pacific_Chatham',
  PacificChuuk = 'Pacific_Chuuk',
  PacificEaster = 'Pacific_Easter',
  PacificEfate = 'Pacific_Efate',
  PacificEnderbury = 'Pacific_Enderbury',
  PacificFakaofo = 'Pacific_Fakaofo',
  PacificFiji = 'Pacific_Fiji',
  PacificFunafuti = 'Pacific_Funafuti',
  PacificGalapagos = 'Pacific_Galapagos',
  PacificGambier = 'Pacific_Gambier',
  PacificGuadalcanal = 'Pacific_Guadalcanal',
  PacificGuam = 'Pacific_Guam',
  PacificHonolulu = 'Pacific_Honolulu',
  PacificJohnston = 'Pacific_Johnston',
  PacificKiritimati = 'Pacific_Kiritimati',
  PacificKosrae = 'Pacific_Kosrae',
  PacificKwajalein = 'Pacific_Kwajalein',
  PacificMajuro = 'Pacific_Majuro',
  PacificMarquesas = 'Pacific_Marquesas',
  PacificMidway = 'Pacific_Midway',
  PacificNauru = 'Pacific_Nauru',
  PacificNiue = 'Pacific_Niue',
  PacificNorfolk = 'Pacific_Norfolk',
  PacificNoumea = 'Pacific_Noumea',
  PacificPagoPago = 'Pacific_Pago_Pago',
  PacificPalau = 'Pacific_Palau',
  PacificPitcairn = 'Pacific_Pitcairn',
  PacificPohnpei = 'Pacific_Pohnpei',
  PacificPortMoresby = 'Pacific_Port_Moresby',
  PacificRarotonga = 'Pacific_Rarotonga',
  PacificSaipan = 'Pacific_Saipan',
  PacificTahiti = 'Pacific_Tahiti',
  PacificTarawa = 'Pacific_Tarawa',
  PacificTongatapu = 'Pacific_Tongatapu',
  PacificWake = 'Pacific_Wake',
  PacificWal = 'Pacific_Wal'
}

export type Error = {
  __typename?: 'Error'
  code: Scalars['String']
  message?: Maybe<Scalars['String']>
}

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']>
  caption?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
}

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
  contains?: InputMaybe<Scalars['Float']>
  containsi?: InputMaybe<Scalars['Float']>
  endsWith?: InputMaybe<Scalars['Float']>
  eq?: InputMaybe<Scalars['Float']>
  gt?: InputMaybe<Scalars['Float']>
  gte?: InputMaybe<Scalars['Float']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
  lt?: InputMaybe<Scalars['Float']>
  lte?: InputMaybe<Scalars['Float']>
  ne?: InputMaybe<Scalars['Float']>
  not?: InputMaybe<FloatFilterInput>
  notContains?: InputMaybe<Scalars['Float']>
  notContainsi?: InputMaybe<Scalars['Float']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
  notNull?: InputMaybe<Scalars['Boolean']>
  null?: InputMaybe<Scalars['Boolean']>
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>
  startsWith?: InputMaybe<Scalars['Float']>
}

export type Font = {
  __typename?: 'Font'
  createdAt?: Maybe<Scalars['DateTime']>
  font_file?: Maybe<UploadFileEntityResponse>
  publishedAt?: Maybe<Scalars['DateTime']>
  title?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type FontEntity = {
  __typename?: 'FontEntity'
  attributes?: Maybe<Font>
  id?: Maybe<Scalars['ID']>
}

export type FontEntityResponse = {
  __typename?: 'FontEntityResponse'
  data?: Maybe<FontEntity>
}

export type FontEntityResponseCollection = {
  __typename?: 'FontEntityResponseCollection'
  data: Array<FontEntity>
  meta: ResponseCollectionMeta
}

export type FontFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FontFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  not?: InputMaybe<FontFiltersInput>
  or?: InputMaybe<Array<InputMaybe<FontFiltersInput>>>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  title?: InputMaybe<StringFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type FontInput = {
  font_file?: InputMaybe<Scalars['ID']>
  publishedAt?: InputMaybe<Scalars['DateTime']>
  title?: InputMaybe<Scalars['String']>
}

export type GenericMorph =
  | ComponentCategoriesCategory
  | ComponentProductsProduct
  | ComponentServicesService
  | Day
  | Font
  | I18NLocale
  | Menu
  | Performance
  | Product
  | Service
  | SubCategory
  | Tag
  | UploadFile
  | UsersPermissionsPermission
  | UsersPermissionsRole
  | UsersPermissionsUser

export type I18NLocale = {
  __typename?: 'I18NLocale'
  code?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['DateTime']>
  name?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity'
  attributes?: Maybe<I18NLocale>
  id?: Maybe<Scalars['ID']>
}

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse'
  data?: Maybe<I18NLocaleEntity>
}

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection'
  data: Array<I18NLocaleEntity>
  meta: ResponseCollectionMeta
}

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>
  code?: InputMaybe<StringFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  name?: InputMaybe<StringFilterInput>
  not?: InputMaybe<I18NLocaleFiltersInput>
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  contains?: InputMaybe<Scalars['ID']>
  containsi?: InputMaybe<Scalars['ID']>
  endsWith?: InputMaybe<Scalars['ID']>
  eq?: InputMaybe<Scalars['ID']>
  gt?: InputMaybe<Scalars['ID']>
  gte?: InputMaybe<Scalars['ID']>
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  lt?: InputMaybe<Scalars['ID']>
  lte?: InputMaybe<Scalars['ID']>
  ne?: InputMaybe<Scalars['ID']>
  not?: InputMaybe<IdFilterInput>
  notContains?: InputMaybe<Scalars['ID']>
  notContainsi?: InputMaybe<Scalars['ID']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  notNull?: InputMaybe<Scalars['Boolean']>
  null?: InputMaybe<Scalars['Boolean']>
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  startsWith?: InputMaybe<Scalars['ID']>
}

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>
  contains?: InputMaybe<Scalars['Int']>
  containsi?: InputMaybe<Scalars['Int']>
  endsWith?: InputMaybe<Scalars['Int']>
  eq?: InputMaybe<Scalars['Int']>
  gt?: InputMaybe<Scalars['Int']>
  gte?: InputMaybe<Scalars['Int']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>
  lt?: InputMaybe<Scalars['Int']>
  lte?: InputMaybe<Scalars['Int']>
  ne?: InputMaybe<Scalars['Int']>
  not?: InputMaybe<IntFilterInput>
  notContains?: InputMaybe<Scalars['Int']>
  notContainsi?: InputMaybe<Scalars['Int']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>
  notNull?: InputMaybe<Scalars['Boolean']>
  null?: InputMaybe<Scalars['Boolean']>
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>
  startsWith?: InputMaybe<Scalars['Int']>
}

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>
  contains?: InputMaybe<Scalars['JSON']>
  containsi?: InputMaybe<Scalars['JSON']>
  endsWith?: InputMaybe<Scalars['JSON']>
  eq?: InputMaybe<Scalars['JSON']>
  gt?: InputMaybe<Scalars['JSON']>
  gte?: InputMaybe<Scalars['JSON']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>
  lt?: InputMaybe<Scalars['JSON']>
  lte?: InputMaybe<Scalars['JSON']>
  ne?: InputMaybe<Scalars['JSON']>
  not?: InputMaybe<JsonFilterInput>
  notContains?: InputMaybe<Scalars['JSON']>
  notContainsi?: InputMaybe<Scalars['JSON']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>
  notNull?: InputMaybe<Scalars['Boolean']>
  null?: InputMaybe<Scalars['Boolean']>
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>
  startsWith?: InputMaybe<Scalars['JSON']>
}

export type Menu = {
  __typename?: 'Menu'
  background_color?: Maybe<Scalars['String']>
  body_font?: Maybe<FontEntityResponse>
  category?: Maybe<Array<Maybe<MenuCategoryDynamicZone>>>
  cover?: Maybe<UploadFileEntityResponse>
  createdAt?: Maybe<Scalars['DateTime']>
  days?: Maybe<DayRelationResponseCollection>
  description?: Maybe<Scalars['String']>
  description_font?: Maybe<FontEntityResponse>
  empty_category_message?: Maybe<Scalars['String']>
  font?: Maybe<UploadFileEntityResponse>
  font_color?: Maybe<Scalars['String']>
  footer_allergens?: Maybe<Scalars['String']>
  footer_team?: Maybe<Scalars['String']>
  footer_thanks_message?: Maybe<Scalars['String']>
  footer_title?: Maybe<Scalars['String']>
  hidden_products?: Maybe<Scalars['JSON']>
  locale: Enum_Menu_Locale
  logo?: Maybe<UploadFileEntityResponse>
  our_surprise?: Maybe<UploadFileEntityResponse>
  our_surprise_link?: Maybe<Scalars['String']>
  password: Scalars['String']
  publishedAt?: Maybe<Scalars['DateTime']>
  quality_content?: Maybe<Scalars['String']>
  quality_or_nothing?: Maybe<UploadFileEntityResponse>
  reservation_button_label?: Maybe<Scalars['String']>
  reservation_url?: Maybe<Scalars['String']>
  restaurant?: Maybe<Scalars['String']>
  restaurant_adress?: Maybe<Scalars['String']>
  secondary_color?: Maybe<Scalars['String']>
  services?: Maybe<Array<Maybe<ComponentServicesService>>>
  show_allergen_button?: Maybe<Scalars['Boolean']>
  show_calories_button?: Maybe<Scalars['Boolean']>
  show_vegetarian_dishes?: Maybe<Scalars['Boolean']>
  slug?: Maybe<Scalars['String']>
  sub_description?: Maybe<Scalars['String']>
  timezone?: Maybe<Enum_Menu_Timezone>
  title?: Maybe<Scalars['String']>
  title_font?: Maybe<FontEntityResponse>
  updatedAt?: Maybe<Scalars['DateTime']>
  wifi_code?: Maybe<Scalars['String']>
}

export type MenuDaysArgs = {
  filters?: InputMaybe<DayFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type MenuServicesArgs = {
  filters?: InputMaybe<ComponentServicesServiceFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type MenuCategoryDynamicZone = ComponentCategoriesCategory | Error

export type MenuEntity = {
  __typename?: 'MenuEntity'
  attributes?: Maybe<Menu>
  id?: Maybe<Scalars['ID']>
}

export type MenuEntityResponse = {
  __typename?: 'MenuEntityResponse'
  data?: Maybe<MenuEntity>
}

export type MenuEntityResponseCollection = {
  __typename?: 'MenuEntityResponseCollection'
  data: Array<MenuEntity>
  meta: ResponseCollectionMeta
}

export type MenuFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MenuFiltersInput>>>
  background_color?: InputMaybe<StringFilterInput>
  body_font?: InputMaybe<FontFiltersInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  days?: InputMaybe<DayFiltersInput>
  description?: InputMaybe<StringFilterInput>
  description_font?: InputMaybe<FontFiltersInput>
  empty_category_message?: InputMaybe<StringFilterInput>
  font_color?: InputMaybe<StringFilterInput>
  footer_allergens?: InputMaybe<StringFilterInput>
  footer_team?: InputMaybe<StringFilterInput>
  footer_thanks_message?: InputMaybe<StringFilterInput>
  footer_title?: InputMaybe<StringFilterInput>
  hidden_products?: InputMaybe<JsonFilterInput>
  id?: InputMaybe<IdFilterInput>
  locale?: InputMaybe<StringFilterInput>
  not?: InputMaybe<MenuFiltersInput>
  or?: InputMaybe<Array<InputMaybe<MenuFiltersInput>>>
  our_surprise_link?: InputMaybe<StringFilterInput>
  password?: InputMaybe<StringFilterInput>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  quality_content?: InputMaybe<StringFilterInput>
  reservation_button_label?: InputMaybe<StringFilterInput>
  reservation_url?: InputMaybe<StringFilterInput>
  restaurant?: InputMaybe<StringFilterInput>
  restaurant_adress?: InputMaybe<StringFilterInput>
  secondary_color?: InputMaybe<StringFilterInput>
  show_allergen_button?: InputMaybe<BooleanFilterInput>
  show_calories_button?: InputMaybe<BooleanFilterInput>
  show_vegetarian_dishes?: InputMaybe<BooleanFilterInput>
  slug?: InputMaybe<StringFilterInput>
  sub_description?: InputMaybe<StringFilterInput>
  timezone?: InputMaybe<StringFilterInput>
  title?: InputMaybe<StringFilterInput>
  title_font?: InputMaybe<FontFiltersInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
  wifi_code?: InputMaybe<StringFilterInput>
}

export type MenuInput = {
  background_color?: InputMaybe<Scalars['String']>
  body_font?: InputMaybe<Scalars['ID']>
  category?: InputMaybe<Array<Scalars['MenuCategoryDynamicZoneInput']>>
  cover?: InputMaybe<Scalars['ID']>
  days?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  description?: InputMaybe<Scalars['String']>
  description_font?: InputMaybe<Scalars['ID']>
  empty_category_message?: InputMaybe<Scalars['String']>
  font?: InputMaybe<Scalars['ID']>
  font_color?: InputMaybe<Scalars['String']>
  footer_allergens?: InputMaybe<Scalars['String']>
  footer_team?: InputMaybe<Scalars['String']>
  footer_thanks_message?: InputMaybe<Scalars['String']>
  footer_title?: InputMaybe<Scalars['String']>
  hidden_products?: InputMaybe<Scalars['JSON']>
  locale?: InputMaybe<Enum_Menu_Locale>
  logo?: InputMaybe<Scalars['ID']>
  our_surprise?: InputMaybe<Scalars['ID']>
  our_surprise_link?: InputMaybe<Scalars['String']>
  password?: InputMaybe<Scalars['String']>
  publishedAt?: InputMaybe<Scalars['DateTime']>
  quality_content?: InputMaybe<Scalars['String']>
  quality_or_nothing?: InputMaybe<Scalars['ID']>
  reservation_button_label?: InputMaybe<Scalars['String']>
  reservation_url?: InputMaybe<Scalars['String']>
  restaurant?: InputMaybe<Scalars['String']>
  restaurant_adress?: InputMaybe<Scalars['String']>
  secondary_color?: InputMaybe<Scalars['String']>
  services?: InputMaybe<Array<InputMaybe<ComponentServicesServiceInput>>>
  show_allergen_button?: InputMaybe<Scalars['Boolean']>
  show_calories_button?: InputMaybe<Scalars['Boolean']>
  show_vegetarian_dishes?: InputMaybe<Scalars['Boolean']>
  slug?: InputMaybe<Scalars['String']>
  sub_description?: InputMaybe<Scalars['String']>
  timezone?: InputMaybe<Enum_Menu_Timezone>
  title?: InputMaybe<Scalars['String']>
  title_font?: InputMaybe<Scalars['ID']>
  wifi_code?: InputMaybe<Scalars['String']>
}

export type Mutation = {
  __typename?: 'Mutation'
  createDay?: Maybe<DayEntityResponse>
  createFont?: Maybe<FontEntityResponse>
  createMenu?: Maybe<MenuEntityResponse>
  createPerformance?: Maybe<PerformanceEntityResponse>
  createProduct?: Maybe<ProductEntityResponse>
  createService?: Maybe<ServiceEntityResponse>
  createSubCategory?: Maybe<SubCategoryEntityResponse>
  createSubCategoryLocalization?: Maybe<SubCategoryEntityResponse>
  createTag?: Maybe<TagEntityResponse>
  createUploadFile?: Maybe<UploadFileEntityResponse>
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse
  deleteDay?: Maybe<DayEntityResponse>
  deleteFont?: Maybe<FontEntityResponse>
  deleteMenu?: Maybe<MenuEntityResponse>
  deletePerformance?: Maybe<PerformanceEntityResponse>
  deleteProduct?: Maybe<ProductEntityResponse>
  deleteService?: Maybe<ServiceEntityResponse>
  deleteSubCategory?: Maybe<SubCategoryEntityResponse>
  deleteTag?: Maybe<TagEntityResponse>
  deleteUploadFile?: Maybe<UploadFileEntityResponse>
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>
  hideProduct?: Maybe<Scalars['String']>
  login: UsersPermissionsLoginPayload
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>
  /** Register a user */
  register: UsersPermissionsLoginPayload
  removeFile?: Maybe<UploadFileEntityResponse>
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>
  setCategoryHidden?: Maybe<Scalars['String']>
  updateDay?: Maybe<DayEntityResponse>
  updateFileInfo: UploadFileEntityResponse
  updateFont?: Maybe<FontEntityResponse>
  updateMenu?: Maybe<MenuEntityResponse>
  updatePerformance?: Maybe<PerformanceEntityResponse>
  updateProduct?: Maybe<ProductEntityResponse>
  updateProductAvailablity?: Maybe<Scalars['String']>
  updateService?: Maybe<ServiceEntityResponse>
  updateSubCategory?: Maybe<SubCategoryEntityResponse>
  updateTag?: Maybe<TagEntityResponse>
  updateUploadFile?: Maybe<UploadFileEntityResponse>
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse
  upload: UploadFileEntityResponse
}

export type MutationCreateDayArgs = {
  data: DayInput
}

export type MutationCreateFontArgs = {
  data: FontInput
}

export type MutationCreateMenuArgs = {
  data: MenuInput
}

export type MutationCreatePerformanceArgs = {
  data: PerformanceInput
}

export type MutationCreateProductArgs = {
  data: ProductInput
}

export type MutationCreateServiceArgs = {
  data: ServiceInput
}

export type MutationCreateSubCategoryArgs = {
  data: SubCategoryInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']>
}

export type MutationCreateSubCategoryLocalizationArgs = {
  data?: InputMaybe<SubCategoryInput>
  id?: InputMaybe<Scalars['ID']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']>
}

export type MutationCreateTagArgs = {
  data: TagInput
}

export type MutationCreateUploadFileArgs = {
  data: UploadFileInput
}

export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput
}

export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput
}

export type MutationDeleteDayArgs = {
  id: Scalars['ID']
}

export type MutationDeleteFontArgs = {
  id: Scalars['ID']
}

export type MutationDeleteMenuArgs = {
  id: Scalars['ID']
}

export type MutationDeletePerformanceArgs = {
  id: Scalars['ID']
}

export type MutationDeleteProductArgs = {
  id: Scalars['ID']
}

export type MutationDeleteServiceArgs = {
  id: Scalars['ID']
}

export type MutationDeleteSubCategoryArgs = {
  id: Scalars['ID']
  locale?: InputMaybe<Scalars['I18NLocaleCode']>
}

export type MutationDeleteTagArgs = {
  id: Scalars['ID']
}

export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']
}

export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']
}

export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']
}

export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']
}

export type MutationForgotPasswordArgs = {
  email: Scalars['String']
}

export type MutationHideProductArgs = {
  product_id: Scalars['ID']
  slug_menu: Scalars['ID']
}

export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput
}

export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']>
  files: Array<InputMaybe<Scalars['Upload']>>
  ref?: InputMaybe<Scalars['String']>
  refId?: InputMaybe<Scalars['ID']>
}

export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput
}

export type MutationRemoveFileArgs = {
  id: Scalars['ID']
}

export type MutationResetPasswordArgs = {
  code: Scalars['String']
  password: Scalars['String']
  passwordConfirmation: Scalars['String']
}

export type MutationSetCategoryHiddenArgs = {
  category_id: Scalars['ID']
  hidden: Scalars['Boolean']
  slug_menu: Scalars['ID']
}

export type MutationUpdateDayArgs = {
  data: DayInput
  id: Scalars['ID']
}

export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']
  info?: InputMaybe<FileInfoInput>
}

export type MutationUpdateFontArgs = {
  data: FontInput
  id: Scalars['ID']
}

export type MutationUpdateMenuArgs = {
  data: MenuInput
  id: Scalars['ID']
}

export type MutationUpdatePerformanceArgs = {
  data: PerformanceInput
  id: Scalars['ID']
}

export type MutationUpdateProductArgs = {
  data: ProductInput
  id: Scalars['ID']
}

export type MutationUpdateProductAvailablityArgs = {
  category_id: Scalars['ID']
  product_id: Scalars['ID']
  relational_product_id: Scalars['ID']
  slug: Scalars['ID']
}

export type MutationUpdateServiceArgs = {
  data: ServiceInput
  id: Scalars['ID']
}

export type MutationUpdateSubCategoryArgs = {
  data: SubCategoryInput
  id: Scalars['ID']
  locale?: InputMaybe<Scalars['I18NLocaleCode']>
}

export type MutationUpdateTagArgs = {
  data: TagInput
  id: Scalars['ID']
}

export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput
  id: Scalars['ID']
}

export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput
  id: Scalars['ID']
}

export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput
  id: Scalars['ID']
}

export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']>
  file: Scalars['Upload']
  info?: InputMaybe<FileInfoInput>
  ref?: InputMaybe<Scalars['String']>
  refId?: InputMaybe<Scalars['ID']>
}

export type Pagination = {
  __typename?: 'Pagination'
  page: Scalars['Int']
  pageCount: Scalars['Int']
  pageSize: Scalars['Int']
  total: Scalars['Int']
}

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']>
  page?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
  start?: InputMaybe<Scalars['Int']>
}

export type Performance = {
  __typename?: 'Performance'
  createdAt?: Maybe<Scalars['DateTime']>
  prods?: Maybe<ComponentProductsProduct>
  publishedAt?: Maybe<Scalars['DateTime']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type PerformanceEntity = {
  __typename?: 'PerformanceEntity'
  attributes?: Maybe<Performance>
  id?: Maybe<Scalars['ID']>
}

export type PerformanceEntityResponse = {
  __typename?: 'PerformanceEntityResponse'
  data?: Maybe<PerformanceEntity>
}

export type PerformanceEntityResponseCollection = {
  __typename?: 'PerformanceEntityResponseCollection'
  data: Array<PerformanceEntity>
  meta: ResponseCollectionMeta
}

export type PerformanceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PerformanceFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  not?: InputMaybe<PerformanceFiltersInput>
  or?: InputMaybe<Array<InputMaybe<PerformanceFiltersInput>>>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type PerformanceInput = {
  prods?: InputMaybe<ComponentProductsProductInput>
  publishedAt?: InputMaybe<Scalars['DateTime']>
}

export type Product = {
  __typename?: 'Product'
  allergens_al?: Maybe<Scalars['String']>
  allergens_ar?: Maybe<Scalars['String']>
  allergens_ca?: Maybe<Scalars['String']>
  allergens_en?: Maybe<Scalars['String']>
  allergens_es?: Maybe<Scalars['String']>
  allergens_fr?: Maybe<Scalars['String']>
  allergens_it?: Maybe<Scalars['String']>
  allergens_nl?: Maybe<Scalars['String']>
  best_of_product?: Maybe<Scalars['Boolean']>
  createdAt?: Maybe<Scalars['DateTime']>
  cta_text_al?: Maybe<Scalars['String']>
  cta_text_ar?: Maybe<Scalars['String']>
  cta_text_ca?: Maybe<Scalars['String']>
  cta_text_en?: Maybe<Scalars['String']>
  cta_text_es?: Maybe<Scalars['String']>
  cta_text_fr?: Maybe<Scalars['String']>
  cta_text_it?: Maybe<Scalars['String']>
  cta_text_nl?: Maybe<Scalars['String']>
  cta_url?: Maybe<Scalars['String']>
  default_price?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  description_al?: Maybe<Scalars['String']>
  description_ar?: Maybe<Scalars['String']>
  description_ca?: Maybe<Scalars['String']>
  description_es?: Maybe<Scalars['String']>
  description_fr?: Maybe<Scalars['String']>
  description_it?: Maybe<Scalars['String']>
  description_nl?: Maybe<Scalars['String']>
  gif?: Maybe<UploadFileEntityResponse>
  image?: Maybe<UploadFileEntityResponse>
  is_vegetarian_product?: Maybe<Scalars['Boolean']>
  is_video_product?: Maybe<Scalars['Boolean']>
  kcal?: Maybe<Scalars['String']>
  pairing_product?: Maybe<ProductEntityResponse>
  pre_title?: Maybe<Scalars['String']>
  price_mention_al?: Maybe<Scalars['String']>
  price_mention_ar?: Maybe<Scalars['String']>
  price_mention_ca?: Maybe<Scalars['String']>
  price_mention_en?: Maybe<Scalars['String']>
  price_mention_es?: Maybe<Scalars['String']>
  price_mention_fr?: Maybe<Scalars['String']>
  price_mention_it?: Maybe<Scalars['String']>
  price_mention_nl?: Maybe<Scalars['String']>
  region?: Maybe<Scalars['String']>
  show_image?: Maybe<Scalars['Boolean']>
  sku?: Maybe<Scalars['String']>
  tag1?: Maybe<TagEntityResponse>
  tag2?: Maybe<TagEntityResponse>
  tag3?: Maybe<TagEntityResponse>
  tag4?: Maybe<TagEntityResponse>
  tag5?: Maybe<TagEntityResponse>
  tags?: Maybe<TagRelationResponseCollection>
  title: Scalars['String']
  title_front?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
  video?: Maybe<UploadFileEntityResponse>
}

export type ProductTagsArgs = {
  filters?: InputMaybe<TagFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ProductEntity = {
  __typename?: 'ProductEntity'
  attributes?: Maybe<Product>
  id?: Maybe<Scalars['ID']>
}

export type ProductEntityResponse = {
  __typename?: 'ProductEntityResponse'
  data?: Maybe<ProductEntity>
}

export type ProductEntityResponseCollection = {
  __typename?: 'ProductEntityResponseCollection'
  data: Array<ProductEntity>
  meta: ResponseCollectionMeta
}

export type ProductFiltersInput = {
  allergens_al?: InputMaybe<StringFilterInput>
  allergens_ar?: InputMaybe<StringFilterInput>
  allergens_ca?: InputMaybe<StringFilterInput>
  allergens_en?: InputMaybe<StringFilterInput>
  allergens_es?: InputMaybe<StringFilterInput>
  allergens_fr?: InputMaybe<StringFilterInput>
  allergens_it?: InputMaybe<StringFilterInput>
  allergens_nl?: InputMaybe<StringFilterInput>
  and?: InputMaybe<Array<InputMaybe<ProductFiltersInput>>>
  best_of_product?: InputMaybe<BooleanFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  cta_text_al?: InputMaybe<StringFilterInput>
  cta_text_ar?: InputMaybe<StringFilterInput>
  cta_text_ca?: InputMaybe<StringFilterInput>
  cta_text_en?: InputMaybe<StringFilterInput>
  cta_text_es?: InputMaybe<StringFilterInput>
  cta_text_fr?: InputMaybe<StringFilterInput>
  cta_text_it?: InputMaybe<StringFilterInput>
  cta_text_nl?: InputMaybe<StringFilterInput>
  cta_url?: InputMaybe<StringFilterInput>
  default_price?: InputMaybe<StringFilterInput>
  description?: InputMaybe<StringFilterInput>
  description_al?: InputMaybe<StringFilterInput>
  description_ar?: InputMaybe<StringFilterInput>
  description_ca?: InputMaybe<StringFilterInput>
  description_es?: InputMaybe<StringFilterInput>
  description_fr?: InputMaybe<StringFilterInput>
  description_it?: InputMaybe<StringFilterInput>
  description_nl?: InputMaybe<StringFilterInput>
  id?: InputMaybe<IdFilterInput>
  is_vegetarian_product?: InputMaybe<BooleanFilterInput>
  is_video_product?: InputMaybe<BooleanFilterInput>
  kcal?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ProductFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ProductFiltersInput>>>
  pairing_product?: InputMaybe<ProductFiltersInput>
  pre_title?: InputMaybe<StringFilterInput>
  price_mention_al?: InputMaybe<StringFilterInput>
  price_mention_ar?: InputMaybe<StringFilterInput>
  price_mention_ca?: InputMaybe<StringFilterInput>
  price_mention_en?: InputMaybe<StringFilterInput>
  price_mention_es?: InputMaybe<StringFilterInput>
  price_mention_fr?: InputMaybe<StringFilterInput>
  price_mention_it?: InputMaybe<StringFilterInput>
  price_mention_nl?: InputMaybe<StringFilterInput>
  region?: InputMaybe<StringFilterInput>
  show_image?: InputMaybe<BooleanFilterInput>
  sku?: InputMaybe<StringFilterInput>
  tag1?: InputMaybe<TagFiltersInput>
  tag2?: InputMaybe<TagFiltersInput>
  tag3?: InputMaybe<TagFiltersInput>
  tag4?: InputMaybe<TagFiltersInput>
  tag5?: InputMaybe<TagFiltersInput>
  tags?: InputMaybe<TagFiltersInput>
  title?: InputMaybe<StringFilterInput>
  title_front?: InputMaybe<StringFilterInput>
  type?: InputMaybe<StringFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type ProductInput = {
  allergens_al?: InputMaybe<Scalars['String']>
  allergens_ar?: InputMaybe<Scalars['String']>
  allergens_ca?: InputMaybe<Scalars['String']>
  allergens_en?: InputMaybe<Scalars['String']>
  allergens_es?: InputMaybe<Scalars['String']>
  allergens_fr?: InputMaybe<Scalars['String']>
  allergens_it?: InputMaybe<Scalars['String']>
  allergens_nl?: InputMaybe<Scalars['String']>
  best_of_product?: InputMaybe<Scalars['Boolean']>
  cta_text_al?: InputMaybe<Scalars['String']>
  cta_text_ar?: InputMaybe<Scalars['String']>
  cta_text_ca?: InputMaybe<Scalars['String']>
  cta_text_en?: InputMaybe<Scalars['String']>
  cta_text_es?: InputMaybe<Scalars['String']>
  cta_text_fr?: InputMaybe<Scalars['String']>
  cta_text_it?: InputMaybe<Scalars['String']>
  cta_text_nl?: InputMaybe<Scalars['String']>
  cta_url?: InputMaybe<Scalars['String']>
  default_price?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  description_al?: InputMaybe<Scalars['String']>
  description_ar?: InputMaybe<Scalars['String']>
  description_ca?: InputMaybe<Scalars['String']>
  description_es?: InputMaybe<Scalars['String']>
  description_fr?: InputMaybe<Scalars['String']>
  description_it?: InputMaybe<Scalars['String']>
  description_nl?: InputMaybe<Scalars['String']>
  gif?: InputMaybe<Scalars['ID']>
  image?: InputMaybe<Scalars['ID']>
  is_vegetarian_product?: InputMaybe<Scalars['Boolean']>
  is_video_product?: InputMaybe<Scalars['Boolean']>
  kcal?: InputMaybe<Scalars['String']>
  pairing_product?: InputMaybe<Scalars['ID']>
  pre_title?: InputMaybe<Scalars['String']>
  price_mention_al?: InputMaybe<Scalars['String']>
  price_mention_ar?: InputMaybe<Scalars['String']>
  price_mention_ca?: InputMaybe<Scalars['String']>
  price_mention_en?: InputMaybe<Scalars['String']>
  price_mention_es?: InputMaybe<Scalars['String']>
  price_mention_fr?: InputMaybe<Scalars['String']>
  price_mention_it?: InputMaybe<Scalars['String']>
  price_mention_nl?: InputMaybe<Scalars['String']>
  region?: InputMaybe<Scalars['String']>
  show_image?: InputMaybe<Scalars['Boolean']>
  sku?: InputMaybe<Scalars['String']>
  tag1?: InputMaybe<Scalars['ID']>
  tag2?: InputMaybe<Scalars['ID']>
  tag3?: InputMaybe<Scalars['ID']>
  tag4?: InputMaybe<Scalars['ID']>
  tag5?: InputMaybe<Scalars['ID']>
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  title?: InputMaybe<Scalars['String']>
  title_front?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
  video?: InputMaybe<Scalars['ID']>
}

export type Products = {
  __typename?: 'Products'
  category_id?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  is_unavailable?: Maybe<Scalars['Boolean']>
  pairing_product?: Maybe<Array<Maybe<Product>>>
  pairing_product_id?: Maybe<Scalars['ID']>
  product_id?: Maybe<Scalars['ID']>
  relational_product_id?: Maybe<Scalars['ID']>
  title?: Maybe<Scalars['String']>
}

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query'
  day?: Maybe<DayEntityResponse>
  days?: Maybe<DayEntityResponseCollection>
  font?: Maybe<FontEntityResponse>
  fonts?: Maybe<FontEntityResponseCollection>
  getAllProductsByMenu?: Maybe<AllProductsRes>
  getAvailableCategories?: Maybe<Scalars['String']>
  i18NLocale?: Maybe<I18NLocaleEntityResponse>
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>
  me?: Maybe<UsersPermissionsMe>
  menu?: Maybe<MenuEntityResponse>
  menus?: Maybe<MenuEntityResponseCollection>
  performance?: Maybe<PerformanceEntityResponse>
  performances?: Maybe<PerformanceEntityResponseCollection>
  product?: Maybe<ProductEntityResponse>
  products?: Maybe<ProductEntityResponseCollection>
  service?: Maybe<ServiceEntityResponse>
  services?: Maybe<ServiceEntityResponseCollection>
  subCategories?: Maybe<SubCategoryEntityResponseCollection>
  subCategory?: Maybe<SubCategoryEntityResponse>
  tag?: Maybe<TagEntityResponse>
  tags?: Maybe<TagEntityResponseCollection>
  uploadFile?: Maybe<UploadFileEntityResponse>
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>
}

export type QueryDayArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryDaysArgs = {
  filters?: InputMaybe<DayFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type QueryFontArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryFontsArgs = {
  filters?: InputMaybe<FontFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type QueryGetAllProductsByMenuArgs = {
  password: Scalars['String']
  slug: Scalars['String']
}

export type QueryGetAvailableCategoriesArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']>
  queryDay?: InputMaybe<Scalars['String']>
  queryURL?: InputMaybe<Scalars['String']>
  slug: Scalars['String']
}

export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type QueryMenuArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryMenusArgs = {
  filters?: InputMaybe<MenuFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type QueryPerformanceArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryPerformancesArgs = {
  filters?: InputMaybe<PerformanceFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type QueryProductArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type QueryServiceArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryServicesArgs = {
  filters?: InputMaybe<ServiceFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type QuerySubCategoriesArgs = {
  filters?: InputMaybe<SubCategoryFiltersInput>
  locale?: InputMaybe<Scalars['I18NLocaleCode']>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type QuerySubCategoryArgs = {
  id?: InputMaybe<Scalars['ID']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']>
}

export type QueryTagArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryTagsArgs = {
  filters?: InputMaybe<TagFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta'
  pagination: Pagination
}

export type Service = {
  __typename?: 'Service'
  createdAt?: Maybe<Scalars['DateTime']>
  publishedAt?: Maybe<Scalars['DateTime']>
  title?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type ServiceEntity = {
  __typename?: 'ServiceEntity'
  attributes?: Maybe<Service>
  id?: Maybe<Scalars['ID']>
}

export type ServiceEntityResponse = {
  __typename?: 'ServiceEntityResponse'
  data?: Maybe<ServiceEntity>
}

export type ServiceEntityResponseCollection = {
  __typename?: 'ServiceEntityResponseCollection'
  data: Array<ServiceEntity>
  meta: ResponseCollectionMeta
}

export type ServiceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ServiceFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  not?: InputMaybe<ServiceFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ServiceFiltersInput>>>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  title?: InputMaybe<StringFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type ServiceInput = {
  publishedAt?: InputMaybe<Scalars['DateTime']>
  title?: InputMaybe<Scalars['String']>
}

export type ServiceRelationResponseCollection = {
  __typename?: 'ServiceRelationResponseCollection'
  data: Array<ServiceEntity>
}

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  contains?: InputMaybe<Scalars['String']>
  containsi?: InputMaybe<Scalars['String']>
  endsWith?: InputMaybe<Scalars['String']>
  eq?: InputMaybe<Scalars['String']>
  gt?: InputMaybe<Scalars['String']>
  gte?: InputMaybe<Scalars['String']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  lt?: InputMaybe<Scalars['String']>
  lte?: InputMaybe<Scalars['String']>
  ne?: InputMaybe<Scalars['String']>
  not?: InputMaybe<StringFilterInput>
  notContains?: InputMaybe<Scalars['String']>
  notContainsi?: InputMaybe<Scalars['String']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  notNull?: InputMaybe<Scalars['Boolean']>
  null?: InputMaybe<Scalars['Boolean']>
  or?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  startsWith?: InputMaybe<Scalars['String']>
}

export type SubCategory = {
  __typename?: 'SubCategory'
  createdAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  description_al?: Maybe<Scalars['String']>
  description_ar?: Maybe<Scalars['String']>
  description_ca?: Maybe<Scalars['String']>
  description_es?: Maybe<Scalars['String']>
  description_fr?: Maybe<Scalars['String']>
  description_it?: Maybe<Scalars['String']>
  description_nl?: Maybe<Scalars['String']>
  hide_filters?: Maybe<Scalars['Boolean']>
  is_accordion?: Maybe<Scalars['Boolean']>
  is_little_addition?: Maybe<Scalars['Boolean']>
  locale?: Maybe<Scalars['String']>
  localizations?: Maybe<SubCategoryRelationResponseCollection>
  publishedAt?: Maybe<Scalars['DateTime']>
  title?: Maybe<Scalars['String']>
  title_front?: Maybe<Scalars['String']>
  title_section1_filter_al?: Maybe<Scalars['String']>
  title_section1_filter_ar?: Maybe<Scalars['String']>
  title_section1_filter_ca?: Maybe<Scalars['String']>
  title_section1_filter_en?: Maybe<Scalars['String']>
  title_section1_filter_es?: Maybe<Scalars['String']>
  title_section1_filter_fr?: Maybe<Scalars['String']>
  title_section1_filter_it?: Maybe<Scalars['String']>
  title_section1_filter_nl?: Maybe<Scalars['String']>
  title_section2_filter_al?: Maybe<Scalars['String']>
  title_section2_filter_ar?: Maybe<Scalars['String']>
  title_section2_filter_ca?: Maybe<Scalars['String']>
  title_section2_filter_en?: Maybe<Scalars['String']>
  title_section2_filter_es?: Maybe<Scalars['String']>
  title_section2_filter_fr?: Maybe<Scalars['String']>
  title_section2_filter_it?: Maybe<Scalars['String']>
  title_section2_filter_nl?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type SubCategoryLocalizationsArgs = {
  filters?: InputMaybe<SubCategoryFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type SubCategoryEntity = {
  __typename?: 'SubCategoryEntity'
  attributes?: Maybe<SubCategory>
  id?: Maybe<Scalars['ID']>
}

export type SubCategoryEntityResponse = {
  __typename?: 'SubCategoryEntityResponse'
  data?: Maybe<SubCategoryEntity>
}

export type SubCategoryEntityResponseCollection = {
  __typename?: 'SubCategoryEntityResponseCollection'
  data: Array<SubCategoryEntity>
  meta: ResponseCollectionMeta
}

export type SubCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubCategoryFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  description?: InputMaybe<StringFilterInput>
  description_al?: InputMaybe<StringFilterInput>
  description_ar?: InputMaybe<StringFilterInput>
  description_ca?: InputMaybe<StringFilterInput>
  description_es?: InputMaybe<StringFilterInput>
  description_fr?: InputMaybe<StringFilterInput>
  description_it?: InputMaybe<StringFilterInput>
  description_nl?: InputMaybe<StringFilterInput>
  hide_filters?: InputMaybe<BooleanFilterInput>
  id?: InputMaybe<IdFilterInput>
  is_accordion?: InputMaybe<BooleanFilterInput>
  is_little_addition?: InputMaybe<BooleanFilterInput>
  locale?: InputMaybe<StringFilterInput>
  localizations?: InputMaybe<SubCategoryFiltersInput>
  not?: InputMaybe<SubCategoryFiltersInput>
  or?: InputMaybe<Array<InputMaybe<SubCategoryFiltersInput>>>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  title?: InputMaybe<StringFilterInput>
  title_front?: InputMaybe<StringFilterInput>
  title_section1_filter_al?: InputMaybe<StringFilterInput>
  title_section1_filter_ar?: InputMaybe<StringFilterInput>
  title_section1_filter_ca?: InputMaybe<StringFilterInput>
  title_section1_filter_en?: InputMaybe<StringFilterInput>
  title_section1_filter_es?: InputMaybe<StringFilterInput>
  title_section1_filter_fr?: InputMaybe<StringFilterInput>
  title_section1_filter_it?: InputMaybe<StringFilterInput>
  title_section1_filter_nl?: InputMaybe<StringFilterInput>
  title_section2_filter_al?: InputMaybe<StringFilterInput>
  title_section2_filter_ar?: InputMaybe<StringFilterInput>
  title_section2_filter_ca?: InputMaybe<StringFilterInput>
  title_section2_filter_en?: InputMaybe<StringFilterInput>
  title_section2_filter_es?: InputMaybe<StringFilterInput>
  title_section2_filter_fr?: InputMaybe<StringFilterInput>
  title_section2_filter_it?: InputMaybe<StringFilterInput>
  title_section2_filter_nl?: InputMaybe<StringFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type SubCategoryInput = {
  description?: InputMaybe<Scalars['String']>
  description_al?: InputMaybe<Scalars['String']>
  description_ar?: InputMaybe<Scalars['String']>
  description_ca?: InputMaybe<Scalars['String']>
  description_es?: InputMaybe<Scalars['String']>
  description_fr?: InputMaybe<Scalars['String']>
  description_it?: InputMaybe<Scalars['String']>
  description_nl?: InputMaybe<Scalars['String']>
  hide_filters?: InputMaybe<Scalars['Boolean']>
  is_accordion?: InputMaybe<Scalars['Boolean']>
  is_little_addition?: InputMaybe<Scalars['Boolean']>
  publishedAt?: InputMaybe<Scalars['DateTime']>
  title?: InputMaybe<Scalars['String']>
  title_front?: InputMaybe<Scalars['String']>
  title_section1_filter_al?: InputMaybe<Scalars['String']>
  title_section1_filter_ar?: InputMaybe<Scalars['String']>
  title_section1_filter_ca?: InputMaybe<Scalars['String']>
  title_section1_filter_en?: InputMaybe<Scalars['String']>
  title_section1_filter_es?: InputMaybe<Scalars['String']>
  title_section1_filter_fr?: InputMaybe<Scalars['String']>
  title_section1_filter_it?: InputMaybe<Scalars['String']>
  title_section1_filter_nl?: InputMaybe<Scalars['String']>
  title_section2_filter_al?: InputMaybe<Scalars['String']>
  title_section2_filter_ar?: InputMaybe<Scalars['String']>
  title_section2_filter_ca?: InputMaybe<Scalars['String']>
  title_section2_filter_en?: InputMaybe<Scalars['String']>
  title_section2_filter_es?: InputMaybe<Scalars['String']>
  title_section2_filter_fr?: InputMaybe<Scalars['String']>
  title_section2_filter_it?: InputMaybe<Scalars['String']>
  title_section2_filter_nl?: InputMaybe<Scalars['String']>
}

export type SubCategoryRelationResponseCollection = {
  __typename?: 'SubCategoryRelationResponseCollection'
  data: Array<SubCategoryEntity>
}

export type Tag = {
  __typename?: 'Tag'
  createdAt?: Maybe<Scalars['DateTime']>
  marketing_title_al?: Maybe<Scalars['String']>
  marketing_title_ar?: Maybe<Scalars['String']>
  marketing_title_ca?: Maybe<Scalars['String']>
  marketing_title_en?: Maybe<Scalars['String']>
  marketing_title_es?: Maybe<Scalars['String']>
  marketing_title_fr?: Maybe<Scalars['String']>
  marketing_title_it?: Maybe<Scalars['String']>
  marketing_title_nl?: Maybe<Scalars['String']>
  product?: Maybe<ProductEntityResponse>
  publishedAt?: Maybe<Scalars['DateTime']>
  title?: Maybe<Scalars['String']>
  title_al?: Maybe<Scalars['String']>
  title_ar?: Maybe<Scalars['String']>
  title_ca?: Maybe<Scalars['String']>
  title_en?: Maybe<Scalars['String']>
  title_es?: Maybe<Scalars['String']>
  title_fr?: Maybe<Scalars['String']>
  title_it?: Maybe<Scalars['String']>
  title_nl?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type TagEntity = {
  __typename?: 'TagEntity'
  attributes?: Maybe<Tag>
  id?: Maybe<Scalars['ID']>
}

export type TagEntityResponse = {
  __typename?: 'TagEntityResponse'
  data?: Maybe<TagEntity>
}

export type TagEntityResponseCollection = {
  __typename?: 'TagEntityResponseCollection'
  data: Array<TagEntity>
  meta: ResponseCollectionMeta
}

export type TagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TagFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  marketing_title_al?: InputMaybe<StringFilterInput>
  marketing_title_ar?: InputMaybe<StringFilterInput>
  marketing_title_ca?: InputMaybe<StringFilterInput>
  marketing_title_en?: InputMaybe<StringFilterInput>
  marketing_title_es?: InputMaybe<StringFilterInput>
  marketing_title_fr?: InputMaybe<StringFilterInput>
  marketing_title_it?: InputMaybe<StringFilterInput>
  marketing_title_nl?: InputMaybe<StringFilterInput>
  not?: InputMaybe<TagFiltersInput>
  or?: InputMaybe<Array<InputMaybe<TagFiltersInput>>>
  product?: InputMaybe<ProductFiltersInput>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  title?: InputMaybe<StringFilterInput>
  title_al?: InputMaybe<StringFilterInput>
  title_ar?: InputMaybe<StringFilterInput>
  title_ca?: InputMaybe<StringFilterInput>
  title_en?: InputMaybe<StringFilterInput>
  title_es?: InputMaybe<StringFilterInput>
  title_fr?: InputMaybe<StringFilterInput>
  title_it?: InputMaybe<StringFilterInput>
  title_nl?: InputMaybe<StringFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type TagInput = {
  marketing_title_al?: InputMaybe<Scalars['String']>
  marketing_title_ar?: InputMaybe<Scalars['String']>
  marketing_title_ca?: InputMaybe<Scalars['String']>
  marketing_title_en?: InputMaybe<Scalars['String']>
  marketing_title_es?: InputMaybe<Scalars['String']>
  marketing_title_fr?: InputMaybe<Scalars['String']>
  marketing_title_it?: InputMaybe<Scalars['String']>
  marketing_title_nl?: InputMaybe<Scalars['String']>
  product?: InputMaybe<Scalars['ID']>
  publishedAt?: InputMaybe<Scalars['DateTime']>
  title?: InputMaybe<Scalars['String']>
  title_al?: InputMaybe<Scalars['String']>
  title_ar?: InputMaybe<Scalars['String']>
  title_ca?: InputMaybe<Scalars['String']>
  title_en?: InputMaybe<Scalars['String']>
  title_es?: InputMaybe<Scalars['String']>
  title_fr?: InputMaybe<Scalars['String']>
  title_it?: InputMaybe<Scalars['String']>
  title_nl?: InputMaybe<Scalars['String']>
}

export type TagRelationResponseCollection = {
  __typename?: 'TagRelationResponseCollection'
  data: Array<TagEntity>
}

export type UploadFile = {
  __typename?: 'UploadFile'
  alternativeText?: Maybe<Scalars['String']>
  caption?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['DateTime']>
  ext?: Maybe<Scalars['String']>
  formats?: Maybe<Scalars['JSON']>
  hash: Scalars['String']
  height?: Maybe<Scalars['Int']>
  mime: Scalars['String']
  name: Scalars['String']
  previewUrl?: Maybe<Scalars['String']>
  provider: Scalars['String']
  provider_metadata?: Maybe<Scalars['JSON']>
  related?: Maybe<Array<Maybe<GenericMorph>>>
  size: Scalars['Float']
  updatedAt?: Maybe<Scalars['DateTime']>
  url: Scalars['String']
  width?: Maybe<Scalars['Int']>
}

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity'
  attributes?: Maybe<UploadFile>
  id?: Maybe<Scalars['ID']>
}

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse'
  data?: Maybe<UploadFileEntity>
}

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection'
  data: Array<UploadFileEntity>
  meta: ResponseCollectionMeta
}

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>
  caption?: InputMaybe<StringFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  ext?: InputMaybe<StringFilterInput>
  formats?: InputMaybe<JsonFilterInput>
  hash?: InputMaybe<StringFilterInput>
  height?: InputMaybe<IntFilterInput>
  id?: InputMaybe<IdFilterInput>
  mime?: InputMaybe<StringFilterInput>
  name?: InputMaybe<StringFilterInput>
  not?: InputMaybe<UploadFileFiltersInput>
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>
  previewUrl?: InputMaybe<StringFilterInput>
  provider?: InputMaybe<StringFilterInput>
  provider_metadata?: InputMaybe<JsonFilterInput>
  size?: InputMaybe<FloatFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
  url?: InputMaybe<StringFilterInput>
  width?: InputMaybe<IntFilterInput>
}

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']>
  caption?: InputMaybe<Scalars['String']>
  ext?: InputMaybe<Scalars['String']>
  formats?: InputMaybe<Scalars['JSON']>
  hash?: InputMaybe<Scalars['String']>
  height?: InputMaybe<Scalars['Int']>
  mime?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  previewUrl?: InputMaybe<Scalars['String']>
  provider?: InputMaybe<Scalars['String']>
  provider_metadata?: InputMaybe<Scalars['JSON']>
  size?: InputMaybe<Scalars['Float']>
  url?: InputMaybe<Scalars['String']>
  width?: InputMaybe<Scalars['Int']>
}

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload'
  ok: Scalars['Boolean']
}

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload'
  ok: Scalars['Boolean']
}

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']
  password: Scalars['String']
  provider?: Scalars['String']
}

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload'
  jwt?: Maybe<Scalars['String']>
  user: UsersPermissionsMe
}

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe'
  blocked?: Maybe<Scalars['Boolean']>
  confirmed?: Maybe<Scalars['Boolean']>
  email?: Maybe<Scalars['String']>
  id: Scalars['ID']
  role?: Maybe<UsersPermissionsMeRole>
  username: Scalars['String']
}

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole'
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  type?: Maybe<Scalars['String']>
}

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload'
  ok: Scalars['Boolean']
}

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission'
  action: Scalars['String']
  createdAt?: Maybe<Scalars['DateTime']>
  role?: Maybe<UsersPermissionsRoleEntityResponse>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity'
  attributes?: Maybe<UsersPermissionsPermission>
  id?: Maybe<Scalars['ID']>
}

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection'
  data: Array<UsersPermissionsPermissionEntity>
}

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']
  password: Scalars['String']
  username: Scalars['String']
}

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole'
  createdAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  name: Scalars['String']
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>
  type?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['DateTime']>
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>
}

export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity'
  attributes?: Maybe<UsersPermissionsRole>
  id?: Maybe<Scalars['ID']>
}

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse'
  data?: Maybe<UsersPermissionsRoleEntity>
}

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection'
  data: Array<UsersPermissionsRoleEntity>
  meta: ResponseCollectionMeta
}

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  description?: InputMaybe<StringFilterInput>
  id?: InputMaybe<IdFilterInput>
  name?: InputMaybe<StringFilterInput>
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>
  type?: InputMaybe<StringFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
  users?: InputMaybe<UsersPermissionsUserFiltersInput>
}

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  type?: InputMaybe<Scalars['String']>
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
}

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload'
  ok: Scalars['Boolean']
}

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser'
  blocked?: Maybe<Scalars['Boolean']>
  confirmed?: Maybe<Scalars['Boolean']>
  createdAt?: Maybe<Scalars['DateTime']>
  email: Scalars['String']
  provider?: Maybe<Scalars['String']>
  role?: Maybe<UsersPermissionsRoleEntityResponse>
  tests?: Maybe<Array<Maybe<UsersPermissionsUserTestsDynamicZone>>>
  updatedAt?: Maybe<Scalars['DateTime']>
  username: Scalars['String']
}

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity'
  attributes?: Maybe<UsersPermissionsUser>
  id?: Maybe<Scalars['ID']>
}

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse'
  data?: Maybe<UsersPermissionsUserEntity>
}

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection'
  data: Array<UsersPermissionsUserEntity>
  meta: ResponseCollectionMeta
}

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>
  blocked?: InputMaybe<BooleanFilterInput>
  confirmationToken?: InputMaybe<StringFilterInput>
  confirmed?: InputMaybe<BooleanFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  email?: InputMaybe<StringFilterInput>
  id?: InputMaybe<IdFilterInput>
  not?: InputMaybe<UsersPermissionsUserFiltersInput>
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>
  password?: InputMaybe<StringFilterInput>
  provider?: InputMaybe<StringFilterInput>
  resetPasswordToken?: InputMaybe<StringFilterInput>
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
  username?: InputMaybe<StringFilterInput>
}

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']>
  confirmationToken?: InputMaybe<Scalars['String']>
  confirmed?: InputMaybe<Scalars['Boolean']>
  email?: InputMaybe<Scalars['String']>
  password?: InputMaybe<Scalars['String']>
  provider?: InputMaybe<Scalars['String']>
  resetPasswordToken?: InputMaybe<Scalars['String']>
  role?: InputMaybe<Scalars['ID']>
  tests?: InputMaybe<Array<Scalars['UsersPermissionsUserTestsDynamicZoneInput']>>
  username?: InputMaybe<Scalars['String']>
}

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection'
  data: Array<UsersPermissionsUserEntity>
}

export type UsersPermissionsUserTestsDynamicZone = Error

export type MenuLayoutQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>
  locale: Scalars['String']
}>

export type MenuLayoutQuery = {
  __typename?: 'Query'
  menus?: {
    __typename?: 'MenuEntityResponseCollection'
    data: Array<{
      __typename?: 'MenuEntity'
      id?: string | null
      attributes?: {
        meta_description?: any
        meta_title?: any
        titre_h1?: any
        __typename?: 'Menu'
        locale: Enum_Menu_Locale
        title?: string | null
        footer_title?: string | null
        description?: string | null
        sub_description?: string | null
        restaurant?: string | null
        restaurant_adress?: string | null
        slug?: string | null
        reservation_url?: string | null
        reservation_button_label?: string | null
        wifi_code?: string | null
        background_color?: string | null
        font_color?: string | null
        secondary_color?: string | null
        footer_team?: string | null
        footer_allergens?: string | null
        footer_thanks_message?: string | null
        timezone?: Enum_Menu_Timezone | null
        show_calories_button?: boolean | null
        show_vegetarian_dishes?: boolean | null
        show_allergen_button?: boolean | null
        quality_content?: string | null
        our_surprise_link?: string | null
        cover?: {
          __typename?: 'UploadFileEntityResponse'
          data?: {
            __typename?: 'UploadFileEntity'
            attributes?: { __typename?: 'UploadFile'; url: string } | null
          } | null
        } | null
        logo?: {
          __typename?: 'UploadFileEntityResponse'
          data?: {
            __typename?: 'UploadFileEntity'
            attributes?: { __typename?: 'UploadFile'; url: string } | null
          } | null
        } | null
        title_font?: {
          __typename?: 'FontEntityResponse'
          data?: {
            __typename?: 'FontEntity'
            id?: string | null
            attributes?: {
              __typename?: 'Font'
              title?: string | null
              font_file?: {
                __typename?: 'UploadFileEntityResponse'
                data?: {
                  __typename?: 'UploadFileEntity'
                  attributes?: { __typename?: 'UploadFile'; url: string } | null
                } | null
              } | null
            } | null
          } | null
        } | null
        description_font?: {
          __typename?: 'FontEntityResponse'
          data?: {
            __typename?: 'FontEntity'
            id?: string | null
            attributes?: {
              __typename?: 'Font'
              title?: string | null
              font_file?: {
                __typename?: 'UploadFileEntityResponse'
                data?: {
                  __typename?: 'UploadFileEntity'
                  attributes?: { __typename?: 'UploadFile'; url: string } | null
                } | null
              } | null
            } | null
          } | null
        } | null
        body_font?: {
          __typename?: 'FontEntityResponse'
          data?: {
            __typename?: 'FontEntity'
            id?: string | null
            attributes?: {
              __typename?: 'Font'
              title?: string | null
              font_file?: {
                __typename?: 'UploadFileEntityResponse'
                data?: {
                  __typename?: 'UploadFileEntity'
                  attributes?: { __typename?: 'UploadFile'; url: string } | null
                } | null
              } | null
            } | null
          } | null
        } | null
        services?: Array<{
          __typename?: 'ComponentServicesService'
          id: string
          startHours?: number | null
          startMinutes?: number | null
          endHours?: number | null
          endMinutes?: number | null
          days?: {
            __typename?: 'DayRelationResponseCollection'
            data: Array<{ __typename?: 'DayEntity'; attributes?: { __typename?: 'Day'; title?: string | null } | null }>
          } | null
          service?: {
            __typename?: 'ServiceEntityResponse'
            data?: {
              __typename?: 'ServiceEntity'
              id?: string | null
              attributes?: { __typename?: 'Service'; title?: string | null } | null
            } | null
          } | null
        } | null> | null
        our_surprise?: {
          __typename?: 'UploadFileEntityResponse'
          data?: {
            __typename?: 'UploadFileEntity'
            id?: string | null
            attributes?: { __typename?: 'UploadFile'; url: string } | null
          } | null
        } | null
        quality_or_nothing?: {
          __typename?: 'UploadFileEntityResponse'
          data?: {
            __typename?: 'UploadFileEntity'
            id?: string | null
            attributes?: { __typename?: 'UploadFile'; url: string } | null
          } | null
        } | null
        days?: {
          __typename?: 'DayRelationResponseCollection'
          data: Array<{
            __typename?: 'DayEntity'
            id?: string | null
            attributes?: { __typename?: 'Day'; title?: string | null } | null
          }>
        } | null
      } | null
    }>
  } | null
}

export type HiddenProductsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>
}>

export type HiddenProductsQuery = {
  __typename?: 'Query'
  menus?: {
    __typename?: 'MenuEntityResponseCollection'
    data: Array<{
      __typename?: 'MenuEntity'
      attributes?: { __typename?: 'Menu'; hidden_products?: any | null } | null
    }>
  } | null
}

export type GetLocalesFromSlugQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type GetLocalesFromSlugQuery = {
  __typename?: 'Query'
  menus?: {
    __typename?: 'MenuEntityResponseCollection'
    data: Array<{ __typename?: 'MenuEntity'; attributes?: { __typename?: 'Menu'; locale: Enum_Menu_Locale } | null }>
  } | null
}

export type AllMenusQueryVariables = Exact<{
  locale: Scalars['String']
}>

export type AllMenusQuery = {
  __typename?: 'Query'
  menus?: {
    __typename?: 'MenuEntityResponseCollection'
    data: Array<{
      __typename?: 'MenuEntity'
      attributes?: {
        __typename?: 'Menu'
        title?: string | null
        slug?: string | null
        font_color?: string | null
        secondary_color?: string | null
      } | null
    }>
  } | null
}

export type GetAvailableCategoriesVariables = Exact<{
  slug: Scalars['String']
  queryURL?: InputMaybe<Scalars['String']>
  queryDay?: InputMaybe<Scalars['String']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']>
}>

export type GetAvailableCategories = { __typename?: 'Query'; getAvailableCategories?: string | null }

export type GetAllProductsByMenuQueryVariables = Exact<{
  slug: Scalars['String']
  password: Scalars['String']
}>

export type GetAllProductsByMenuQuery = {
  __typename?: 'Query'
  getAllProductsByMenu?: {
    __typename?: 'AllProductsRes'
    title?: string | null
    categories?: Array<{
      __typename?: 'AdminCategory'
      category_id?: string | null
      category_title?: string | null
      menu_title?: string | null
      product_ids?: Array<string | null> | null
      total_products?: number | null
      hidden_products_count?: number | null
      visible_products_count?: number | null
      is_offline?: boolean | null
      is_partially_offline?: boolean | null
    } | null> | null
    products?: Array<{
      __typename?: 'Products'
      description?: string | null
      title?: string | null
      is_unavailable?: boolean | null
      pairing_product_id?: string | null
      category_id?: string | null
      product_id?: string | null
      relational_product_id?: string | null
      pairing_product?: Array<{
        __typename?: 'Product'
        title: string
        description?: string | null
        pre_title?: string | null
      } | null> | null
    } | null> | null
  } | null
}

export type UpdateProductAvailablityMutationVariables = Exact<{
  product_id: Scalars['ID']
  relational_product_id: Scalars['ID']
  category_id: Scalars['ID']
  slug: Scalars['ID']
}>

export type UpdateProductAvailablityMutation = { __typename?: 'Mutation'; updateProductAvailablity?: string | null }

export type HideProductMutationVariables = Exact<{
  product_id: Scalars['ID']
  slug_menu: Scalars['ID']
}>

export type HideProductMutation = { __typename?: 'Mutation'; hideProduct?: string | null }

export type SetCategoryHiddenMutationVariables = Exact<{
  category_id: Scalars['ID']
  slug_menu: Scalars['ID']
  hidden: Scalars['Boolean']
}>

export type SetCategoryHiddenMutation = { __typename?: 'Mutation'; setCategoryHidden?: string | null }

export const MenuLayoutQueryDocument = `
    query menuLayoutQuery($slug: String, $locale: String!) {
  menus(filters: {slug: {eq: $slug}, and: {locale: {eq: $locale}}}) {
    data {
      id
      attributes {
        locale
        cover {
          data {
            attributes {
              url
            }
          }
        }
        title
        footer_title
        meta_title
        meta_description
        titre_h1
        description
        sub_description
        restaurant
        restaurant_adress
        slug
        reservation_url
        reservation_button_label
        wifi_code
        background_color
        font_color
        secondary_color
        logo {
          data {
            attributes {
              url
            }
          }
        }
        footer_team
        footer_allergens
        footer_thanks_message
        timezone
        title_font {
          data {
            attributes {
              title
              font_file {
                data {
                  attributes {
                    url
                  }
                }
              }
            }
          }
        }
        description_font {
          data {
            attributes {
              title
              font_file {
                data {
                  attributes {
                    url
                  }
                }
              }
            }
          }
        }
        body_font {
          data {
            attributes {
              title
              font_file {
                data {
                  attributes {
                    url
                  }
                }
              }
            }
          }
        }
        services {
          id
          startHours
          startMinutes
          endHours
          endMinutes
          days {
            data {
              attributes {
                title
              }
            }
          }
          service {
            data {
              id
              attributes {
                title
              }
            }
          }
        }
        our_surprise {
          data {
            id
            attributes {
              url
            }
          }
        }
        show_calories_button
        show_vegetarian_dishes
        show_allergen_button
        quality_or_nothing {
          data {
            id
            attributes {
              url
            }
          }
        }
        quality_content
        our_surprise_link
        title_font {
          data {
            id
            attributes {
              title
            }
          }
        }
        body_font {
          data {
            id
            attributes {
              title
            }
          }
        }
        description_font {
          data {
            id
            attributes {
              title
            }
          }
        }
        days {
          data {
            id
            attributes {
              title
            }
          }
        }
      }
    }
  }
}
    `
export const useMenuLayoutQuery = <TData = MenuLayoutQuery, TError = unknown>(
  client: GraphQLClient,
  variables: MenuLayoutQueryVariables,
  options?: UseQueryOptions<MenuLayoutQuery, TError, TData>,
  headers?: RequestInit['headers']
) =>
  useQuery<MenuLayoutQuery, TError, TData>(
    ['menuLayoutQuery', variables],
    fetcher<MenuLayoutQuery, MenuLayoutQueryVariables>(client, MenuLayoutQueryDocument, variables, headers),
    options
  )
export const useInfiniteMenuLayoutQuery = <TData = MenuLayoutQuery, TError = unknown>(
  pageParamKey: keyof MenuLayoutQueryVariables,
  client: GraphQLClient,
  variables: MenuLayoutQueryVariables,
  options?: UseInfiniteQueryOptions<MenuLayoutQuery, TError, TData>,
  headers?: RequestInit['headers']
) =>
  useInfiniteQuery<MenuLayoutQuery, TError, TData>(
    ['menuLayoutQuery.infinite', variables],
    (metaData) =>
      fetcher<MenuLayoutQuery, MenuLayoutQueryVariables>(
        client,
        MenuLayoutQueryDocument,
        { ...variables, ...(metaData.pageParam ?? {}) },
        headers
      )(),
    options
  )

export const HiddenProductsQueryDocument = `
    query hiddenProductsQuery($slug: String) {
  menus(filters: {slug: {eq: $slug}, and: {locale: {eq: "en"}}}) {
    data {
      attributes {
        hidden_products
      }
    }
  }
}
    `
export const useHiddenProductsQuery = <TData = HiddenProductsQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: HiddenProductsQueryVariables,
  options?: UseQueryOptions<HiddenProductsQuery, TError, TData>,
  headers?: RequestInit['headers']
) =>
  useQuery<HiddenProductsQuery, TError, TData>(
    variables === undefined ? ['hiddenProductsQuery'] : ['hiddenProductsQuery', variables],
    fetcher<HiddenProductsQuery, HiddenProductsQueryVariables>(client, HiddenProductsQueryDocument, variables, headers),
    options
  )
export const useInfiniteHiddenProductsQuery = <TData = HiddenProductsQuery, TError = unknown>(
  pageParamKey: keyof HiddenProductsQueryVariables,
  client: GraphQLClient,
  variables?: HiddenProductsQueryVariables,
  options?: UseInfiniteQueryOptions<HiddenProductsQuery, TError, TData>,
  headers?: RequestInit['headers']
) =>
  useInfiniteQuery<HiddenProductsQuery, TError, TData>(
    variables === undefined ? ['hiddenProductsQuery.infinite'] : ['hiddenProductsQuery.infinite', variables],
    (metaData) =>
      fetcher<HiddenProductsQuery, HiddenProductsQueryVariables>(
        client,
        HiddenProductsQueryDocument,
        { ...variables, ...(metaData.pageParam ?? {}) },
        headers
      )(),
    options
  )

export const GetLocalesFromSlugQueryDocument = `
    query getLocalesFromSlugQuery($slug: String!) {
  menus(filters: {slug: {eq: $slug}}) {
    data {
      attributes {
        locale
      }
    }
  }
}
    `
export const useGetLocalesFromSlugQuery = <TData = GetLocalesFromSlugQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetLocalesFromSlugQueryVariables,
  options?: UseQueryOptions<GetLocalesFromSlugQuery, TError, TData>,
  headers?: RequestInit['headers']
) =>
  useQuery<GetLocalesFromSlugQuery, TError, TData>(
    ['getLocalesFromSlugQuery', variables],
    fetcher<GetLocalesFromSlugQuery, GetLocalesFromSlugQueryVariables>(
      client,
      GetLocalesFromSlugQueryDocument,
      variables,
      headers
    ),
    options
  )
export const useInfiniteGetLocalesFromSlugQuery = <TData = GetLocalesFromSlugQuery, TError = unknown>(
  pageParamKey: keyof GetLocalesFromSlugQueryVariables,
  client: GraphQLClient,
  variables: GetLocalesFromSlugQueryVariables,
  options?: UseInfiniteQueryOptions<GetLocalesFromSlugQuery, TError, TData>,
  headers?: RequestInit['headers']
) =>
  useInfiniteQuery<GetLocalesFromSlugQuery, TError, TData>(
    ['getLocalesFromSlugQuery.infinite', variables],
    (metaData) =>
      fetcher<GetLocalesFromSlugQuery, GetLocalesFromSlugQueryVariables>(
        client,
        GetLocalesFromSlugQueryDocument,
        { ...variables, ...(metaData.pageParam ?? {}) },
        headers
      )(),
    options
  )

export const AllMenusQueryDocument = `
    query allMenusQuery($locale: String!) {
  menus(filters: {locale: {eq: $locale}}) {
    data {
      attributes {
        title
        slug
        font_color
        secondary_color
      }
    }
  }
}
    `
export const useAllMenusQuery = <TData = AllMenusQuery, TError = unknown>(
  client: GraphQLClient,
  variables: AllMenusQueryVariables,
  options?: UseQueryOptions<AllMenusQuery, TError, TData>,
  headers?: RequestInit['headers']
) =>
  useQuery<AllMenusQuery, TError, TData>(
    ['allMenusQuery', variables],
    fetcher<AllMenusQuery, AllMenusQueryVariables>(client, AllMenusQueryDocument, variables, headers),
    options
  )
export const useInfiniteAllMenusQuery = <TData = AllMenusQuery, TError = unknown>(
  pageParamKey: keyof AllMenusQueryVariables,
  client: GraphQLClient,
  variables: AllMenusQueryVariables,
  options?: UseInfiniteQueryOptions<AllMenusQuery, TError, TData>,
  headers?: RequestInit['headers']
) =>
  useInfiniteQuery<AllMenusQuery, TError, TData>(
    ['allMenusQuery.infinite', variables],
    (metaData) =>
      fetcher<AllMenusQuery, AllMenusQueryVariables>(
        client,
        AllMenusQueryDocument,
        { ...variables, ...(metaData.pageParam ?? {}) },
        headers
      )(),
    options
  )

export const GetAvailableCategoriesDocument = `
    query getAvailableCategories($slug: String!, $queryURL: String, $queryDay: String, $locale: I18NLocaleCode) {
  getAvailableCategories(
    slug: $slug
    queryURL: $queryURL
    queryDay: $queryDay
    locale: $locale
  )
}
    `
export const useGetAvailableCategories = <TData = GetAvailableCategories, TError = unknown>(
  client: GraphQLClient,
  variables: GetAvailableCategoriesVariables,
  options?: UseQueryOptions<GetAvailableCategories, TError, TData>,
  headers?: RequestInit['headers']
) =>
  useQuery<GetAvailableCategories, TError, TData>(
    ['getAvailableCategories', variables],
    fetcher<GetAvailableCategories, GetAvailableCategoriesVariables>(
      client,
      GetAvailableCategoriesDocument,
      variables,
      headers
    ),
    options
  )
export const useInfiniteGetAvailableCategories = <TData = GetAvailableCategories, TError = unknown>(
  pageParamKey: keyof GetAvailableCategoriesVariables,
  client: GraphQLClient,
  variables: GetAvailableCategoriesVariables,
  options?: UseInfiniteQueryOptions<GetAvailableCategories, TError, TData>,
  headers?: RequestInit['headers']
) =>
  useInfiniteQuery<GetAvailableCategories, TError, TData>(
    ['getAvailableCategories.infinite', variables],
    (metaData) =>
      fetcher<GetAvailableCategories, GetAvailableCategoriesVariables>(
        client,
        GetAvailableCategoriesDocument,
        { ...variables, ...(metaData.pageParam ?? {}) },
        headers
      )(),
    options
  )

export const GetAllProductsByMenuQueryDocument = `
    query getAllProductsByMenuQuery($slug: String!, $password: String!) {
  getAllProductsByMenu(slug: $slug, password: $password) {
    title
    categories {
      category_id
      category_title
      menu_title
      product_ids
      total_products
      hidden_products_count
      visible_products_count
      is_offline
      is_partially_offline
    }
    products {
      description
      title
      is_unavailable
      pairing_product {
        title
        description
        pre_title
      }
      pairing_product_id
      category_id
      product_id
      relational_product_id
    }
  }
}
    `
export const useGetAllProductsByMenuQuery = <TData = GetAllProductsByMenuQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllProductsByMenuQueryVariables,
  options?: UseQueryOptions<GetAllProductsByMenuQuery, TError, TData>,
  headers?: RequestInit['headers']
) =>
  useQuery<GetAllProductsByMenuQuery, TError, TData>(
    ['getAllProductsByMenuQuery', variables],
    fetcher<GetAllProductsByMenuQuery, GetAllProductsByMenuQueryVariables>(
      client,
      GetAllProductsByMenuQueryDocument,
      variables,
      headers
    ),
    options
  )
export const useInfiniteGetAllProductsByMenuQuery = <TData = GetAllProductsByMenuQuery, TError = unknown>(
  pageParamKey: keyof GetAllProductsByMenuQueryVariables,
  client: GraphQLClient,
  variables: GetAllProductsByMenuQueryVariables,
  options?: UseInfiniteQueryOptions<GetAllProductsByMenuQuery, TError, TData>,
  headers?: RequestInit['headers']
) =>
  useInfiniteQuery<GetAllProductsByMenuQuery, TError, TData>(
    ['getAllProductsByMenuQuery.infinite', variables],
    (metaData) =>
      fetcher<GetAllProductsByMenuQuery, GetAllProductsByMenuQueryVariables>(
        client,
        GetAllProductsByMenuQueryDocument,
        { ...variables, ...(metaData.pageParam ?? {}) },
        headers
      )(),
    options
  )

export const UpdateProductAvailablityMutationDocument = `
    mutation updateProductAvailablityMutation($product_id: ID!, $relational_product_id: ID!, $category_id: ID!, $slug: ID!) {
  updateProductAvailablity(
    product_id: $product_id
    relational_product_id: $relational_product_id
    category_id: $category_id
    slug: $slug
  )
}
    `
export const useUpdateProductAvailablityMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateProductAvailablityMutation,
    TError,
    UpdateProductAvailablityMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) =>
  useMutation<UpdateProductAvailablityMutation, TError, UpdateProductAvailablityMutationVariables, TContext>(
    ['updateProductAvailablityMutation'],
    (variables?: UpdateProductAvailablityMutationVariables) =>
      fetcher<UpdateProductAvailablityMutation, UpdateProductAvailablityMutationVariables>(
        client,
        UpdateProductAvailablityMutationDocument,
        variables,
        headers
      )(),
    options
  )
export const HideProductMutationDocument = `
    mutation hideProductMutation($product_id: ID!, $slug_menu: ID!) {
  hideProduct(product_id: $product_id, slug_menu: $slug_menu)
}
    `
export const useHideProductMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<HideProductMutation, TError, HideProductMutationVariables, TContext>,
  headers?: RequestInit['headers']
) =>
  useMutation<HideProductMutation, TError, HideProductMutationVariables, TContext>(
    ['hideProductMutation'],
    (variables?: HideProductMutationVariables) =>
      fetcher<HideProductMutation, HideProductMutationVariables>(
        client,
        HideProductMutationDocument,
        variables,
        headers
      )(),
    options
  )
export const SetCategoryHiddenMutationDocument = `
    mutation setCategoryHiddenMutation($category_id: ID!, $slug_menu: ID!, $hidden: Boolean!) {
  setCategoryHidden(
    category_id: $category_id
    slug_menu: $slug_menu
    hidden: $hidden
  )
}
    `
export const useSetCategoryHiddenMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<SetCategoryHiddenMutation, TError, SetCategoryHiddenMutationVariables, TContext>,
  headers?: RequestInit['headers']
) =>
  useMutation<SetCategoryHiddenMutation, TError, SetCategoryHiddenMutationVariables, TContext>(
    ['setCategoryHiddenMutation'],
    (variables?: SetCategoryHiddenMutationVariables) =>
      fetcher<SetCategoryHiddenMutation, SetCategoryHiddenMutationVariables>(
        client,
        SetCategoryHiddenMutationDocument,
        variables,
        headers
      )(),
    options
  )
